import type { Messages } from "./types";
import { createSetupMessages } from "./setup-messages";

export const ko: Messages = {
  language: {
    code: "ko",
    name: "한국어"
  },
  common: {
    apply: "적용",
    cancel: "취소",
    close: "닫기",
    confirm: "확인",
    delete: "삭제",
    reset: "초기화",
    save: "저장",
    fused: "융합",
    unsavedChangesConfirm: "저장하지 않은 변경사항이 있습니다. 저장하지 않고 이동할까요?",
    saveStatus: {
      idle: "변경 없음",
      pending: "저장 대기",
      saving: "저장 중",
      queued: "추가 저장 대기",
      saved: "저장 완료",
      error: "저장 실패"
    }
  },
  tabs: {
    dashboard: "대시보드",
    floorplan: "평면도",
    stats: "감지 통계",
    zones: "구역 설정",
    backup: "관리/백업"
  },
  setup: createSetupMessages("ko"),
  api: {
    errors: {
      site_configuration_owner_required:
        "공유 평면도는 설정 원본 기기에서 수정하세요. 이 기기에서는 로컬 레이더 위치만 유지합니다.",
      site_configuration_conflict:
        "연결된 기기 사이의 공유 설정이 서로 다릅니다. 감지는 계속되지만 복구가 끝날 때까지 공유 설정을 변경할 수 없습니다.",
      site_configuration_continuity_unavailable:
        "대체 기기가 최신 공유 평면도를 아직 확인하지 못했습니다. 감지는 계속되며, 다시 연결될 때까지 공유 설정 변경만 잠시 멈춥니다.",
      floorplan_manifest_invalid:
        "공유 평면도를 확정하지 못했습니다. 이미지와 방 구조가 저장되었는지 확인하세요.",
      floorplan_delete_requires_standalone:
        "공유 평면도를 삭제하려면 먼저 다른 NAMO 기기의 연동을 해제하세요. 연결된 상태에서는 평면도를 교체할 수 있습니다.",
      invalid_request: "요청 형식이 올바르지 않습니다. 입력값을 확인한 뒤 다시 시도하세요.",
      config_not_found: "저장된 설정을 찾지 못했습니다.",
      config_write_failed: "장치가 설정을 저장하지 못했습니다.",
      image_not_found: "저장된 평면도 이미지를 찾지 못했습니다.",
      config_read_failed: "저장된 평면도 설정을 읽지 못했습니다.",
      image_read_failed: "저장된 평면도 이미지를 읽지 못했습니다.",
      missing_data: "필수 데이터가 없습니다.",
      missing_confirm: "확인이 필요합니다.",
      delete_failed: "저장된 데이터를 삭제하지 못했습니다.",
      upload_session_mismatch: "업로드 세션이 맞지 않습니다. 다시 저장해 보세요.",
      upload_offset_mismatch: "업로드 조각 순서가 맞지 않습니다. 다시 저장해 보세요.",
      upload_incomplete: "업로드가 끝까지 완료되지 않았습니다. 다시 저장해 보세요.",
      upload_payload_too_large: "업로드 데이터가 장치 저장 공간 한도를 초과했습니다.",
      upload_storage_failed: "장치가 업로드 데이터를 저장하지 못했습니다.",
      payload_too_large: "업로드 데이터가 장치 저장 공간 한도를 초과했습니다.",
      api_key_unavailable: "API 키 서비스를 사용할 수 없습니다.",
      api_key_not_set: "저장된 API 키가 없습니다.",
      api_key_unsupported: "이 빌드에서는 API 키 확인을 지원하지 않습니다.",
      api_key_random_failed: "안전한 API 키를 만들지 못했습니다.",
      api_key_save_failed: "새 API 키를 저장하지 못했습니다.",
      nothing_selected: "초기화할 항목을 선택하세요.",
      space_reset_failed: "평면도와 배치를 초기화하지 못했습니다.",
      detection_reset_failed: "감지 설정을 초기화하지 못했습니다.",
      connections_reset_failed: "연결된 기기 정보를 초기화하지 못했습니다.",
      stats_reset_failed: "통계 초기화에 실패했습니다.",
      wifi_not_ready: "Wi-Fi 설정이 아직 준비되지 않았습니다.",
      wifi_unavailable: "Wi-Fi를 사용할 수 없습니다.",
      open_wifi_unsupported: "오픈 Wi-Fi는 지원하지 않습니다.",
      invalid_password_length: "Wi-Fi 비밀번호는 8~63자여야 합니다.",
      firmware_upload_failed: "펌웨어 업로드에 실패했습니다.",
      firmware_network_error: "펌웨어 업로드 중 네트워크 오류가 발생했습니다.",
      firmware_upload_aborted: "펌웨어 업로드가 취소되었습니다.",
      firmware_trust_unavailable: "이 기기에서 펌웨어 검증을 사용할 수 없습니다.",
      firmware_header_invalid: "펌웨어 패키지 정보가 올바르지 않습니다.",
      alpha_firmware_not_allowed: "알파 펌웨어 설치가 허용되지 않았습니다. 관리/백업에서 1회 설치를 먼저 허용하세요.",
      alpha_firmware_permission_invalid: "알파 펌웨어 설치 허용 요청이 올바르지 않습니다.",
      signed_firmware_required: "서명된 NAMO 펌웨어 패키지(.namo-ota)를 선택하세요.",
      legacy_firmware_bin_required: "이전 펌웨어에는 ESP32 OTA .bin 파일이 필요합니다.",
      firmware_session_invalid: "기기가 잘못된 펌웨어 업데이트 세션을 반환했습니다.",
      busy: "다른 펌웨어 업데이트가 이미 진행 중입니다.",
      session_mismatch: "펌웨어 업데이트 세션이 더 이상 일치하지 않습니다.",
      header_mismatch: "업로드한 펌웨어가 사전 검증한 패키지와 다릅니다.",
      trust_rejected: "펌웨어 서명 또는 신뢰 버전이 거부되었습니다.",
      offset_mismatch: "펌웨어 조각의 순서가 올바르지 않습니다.",
      size_mismatch: "펌웨어 패키지 크기가 서명 정보와 다릅니다.",
      expired: "펌웨어 업로드 세션 시간이 만료되었습니다.",
      sink_begin_failed: "펌웨어 업데이트 파티션을 열지 못했습니다.",
      sink_write_failed: "펌웨어 업데이트 기록에 실패했습니다.",
      sink_finish_failed: "최종 펌웨어 또는 신뢰 검증에 실패했습니다."
    },
    statuses: {
      setup_wifi_connecting: "Wi-Fi에 연결하는 중입니다.",
      setup_wifi_connected: "Wi-Fi가 연결되었습니다.",
      setup_wifi_failed: "Wi-Fi 연결에 실패했습니다.",
      ha_handoff_started: "Home Assistant handoff가 시작되었습니다.",
      api_client_waiting: "Native API client 연결을 기다리는 중입니다.",
      api_client_connected: "Native API client가 연결되었습니다.",
      api_client_idle: "Native API client가 대기 중입니다.",
      api_service_not_ready: "Native API가 아직 준비되지 않았습니다."
    }
  },
  app: {
    statusWaiting: "연결 대기",
    configLoaded: "설정 로드 완료",
    configReadFailed: (error) => `설정을 읽지 못했습니다. ${error}`,
    configSaved: "설정 저장 완료",
    configSaveFailed: (error) => `설정을 저장하지 못했습니다. ${error}`,
    stateConnected: "연결됨",
    stateReadFailed: (error) => `상태를 읽지 못했습니다. ${error}`,
    statsReadFailed: (error) => `통계를 읽지 못했습니다: ${error}`,
    systemStatusApiNotReady: "시스템 정보 API가 준비되지 않았습니다.",
    controlApiNotReady: "제어 API가 준비되지 않았습니다.",
    statusLedApiNotReady: "Status LED 제어 API가 준비되지 않았습니다.",
    statusLedOn: "Status LED를 켰습니다.",
    statusLedOff: "Status LED를 껐습니다.",
    statusLedFailed: (error) => `Status LED 제어 실패: ${error}`,
    ledDurationApiNotReady: "LED 시간 제어 API가 준비되지 않았습니다.",
    ledDurationChanged: "LED 자동 꺼짐 시간을 변경했습니다.",
    ledDurationFailed: (error) => `LED 시간 변경 실패: ${error}`,
    environmentCorrectionApiNotReady: "온습도 보정 API가 준비되지 않았습니다.",
    environmentCorrectionOn: "온습도 보정을 켰습니다.",
    environmentCorrectionOff: "온습도 보정을 껐습니다.",
    environmentCorrectionFailed: (error) => `온습도 보정 변경 실패: ${error}`,
    legacyPresenceFallbackOn: "구형 감지 fallback을 켰습니다.",
    legacyPresenceFallbackOff: "구형 감지 fallback을 껐습니다.",
    legacyPresenceFallbackFailed: (error) => `구형 감지 fallback 변경 실패: ${error}`,
    temperatureOffsetApiNotReady: "온도 보정 API가 준비되지 않았습니다.",
    temperatureOffsetChanged: "온도 보정값을 변경했습니다.",
    temperatureOffsetFailed: (error) => `온도 보정값 변경 실패: ${error}`,
    humidityOffsetApiNotReady: "습도 보정 API가 준비되지 않았습니다.",
    humidityOffsetChanged: "습도 보정값을 변경했습니다.",
    humidityOffsetFailed: (error) => `습도 보정값 변경 실패: ${error}`,
    timezoneApiNotReady: "시간대 변경 API가 준비되지 않았습니다.",
    timezoneChanged: "시간대를 변경했습니다. 오늘 통계는 0부터 다시 집계합니다.",
    timezoneApplyTimeout: "기기가 시간대 적용을 제시간에 완료하지 못했습니다.",
    timezoneFailed: (error) => `시간대 변경 실패: ${error}`,
    floorplanSaveApiNotReady: "평면도 저장 API가 준비되지 않았습니다.",
    setupModeSelectMessage: "사용할 연동 방식을 선택하세요.",
    setupInitialChecking: "초기 연동 상태를 확인합니다.",
    haApiWarmupMessage: "Home Assistant API 연결을 확인하는 중입니다. 이 과정은 약 1분 정도 걸릴 수 있습니다.",
    haApiWarningMessage:
      "Home Assistant 연결이 아직 확인되지 않습니다. 이미 기기를 추가했다면 네트워크와 Native API 설정을 확인하세요.",
    haApiWarmupChecking:
      "네트워크가 잠시 불안정할 수 있습니다. Home Assistant API 연결 상태를 확인하는 중입니다.",
    haApiWaitingElapsed: (seconds) => `Home Assistant API 연결을 기다리는 중입니다. ${seconds}초 경과`,
    deviceNetworkPreparing: "기기가 네트워크를 정리하는 중입니다. 응답을 기다리고 있습니다.",
    deviceWaitingWifiSwitch: "기기 응답을 기다리는 중입니다. Wi-Fi가 잠시 전환될 수 있습니다.",
    setupTitles: {
      select: "사용 환경을 선택하세요",
      edge: "초기 설정을 마무리하는 중",
      haSetup: "Home Assistant 연동 준비",
      apiWarmup: "Home Assistant 연결 대기 중",
      apiWarning: "Home Assistant 연결을 확인하세요"
    },
    setupBodies: {
      select:
        "SmartThings Edge만 사용할지, Home Assistant도 함께 사용할지 선택하세요. 나중에 Home Assistant를 사용하게 되면 다시 연동할 수 있습니다.",
      edge: "초기 설정을 마무리하는 중입니다. Wi-Fi 연결이 잠시 불안정할 수 있습니다.",
      haSetup: "확인을 누르면 Home Assistant 연동 준비를 마무리합니다. 연결 확인에는 약 1분 정도 걸릴 수 있습니다.",
      apiWarmup: "Home Assistant 연동 준비가 아직 마무리되지 않았습니다. 확인을 누르면 API 연결 준비를 진행합니다.",
      apiWarning:
        "Home Assistant 연결이 아직 확인되지 않습니다. 확인을 눌러 API 연결 준비를 다시 진행한 뒤, Home Assistant에서 기기 추가 상태와 API 암호화 키를 확인하세요."
    },
    setupContinueDashboard: "대시보드 계속 사용",
    setupFinishingBusy: "마무리 중...",
    setupPreparingBusy: "연동 준비 중...",
    setupConfirmContinue: "확인하고 계속",
    setupFinishingEdge: "초기 설정을 마무리하고 있습니다. Wi-Fi 연결이 잠시 불안정할 수 있습니다.",
    setupFinishingHa: "Home Assistant 연동을 위해 네트워크 설정을 마무리하는 중입니다.",
    setupFinishFailed: (error) => `초기 설정을 마무리하지 못했습니다. ${error}`,
    edgeModeSet: "SmartThings Edge 중심으로 사용하도록 설정했습니다.",
    haModeSet: "Home Assistant도 함께 사용하도록 설정했습니다.",
    haSetupNeeded: "Home Assistant 연동 준비가 필요합니다.",
    integrationModeChangeFailed: (error) => `사용 환경을 변경하지 못했습니다. ${error}`,
    setupRequestSent: "초기 설정 요청을 보냈습니다. 대시보드는 계속 사용할 수 있습니다.",
    haApiCheckingLong: "Home Assistant API 연결 상태를 확인하는 중입니다. 약 1분 정도 걸릴 수 있습니다.",
    haSetupReadyNotice:
      "기기 설정은 완료되었습니다. Home Assistant 연결 확인에는 최대 1분 정도 걸릴 수 있습니다. 잠시 후 Home Assistant에서 기기 상태를 확인해 주세요.",
    haSetupCompleteFailed: (error) => `연동 준비를 완료하지 못했습니다. ${error}`,
    demo: "데모",
    haIntegrationTitle: "Home Assistant 연동",
    haDocsLabel: "ESPHome Native API 문서",
    haDocsSuffix: "를 참고해 Home Assistant 연결 상태를 확인하세요.",
    edgeOnly: "SmartThings Edge만 사용",
    haAlso: "Home Assistant도 사용"
  },
  dashboard: {
    title: "대시보드",
    description: "센서 상태와 실시간 감지 정보를 한 화면에서 확인합니다.",
    demoMode: "데모 모드입니다. 실제 기기에 저장되지 않습니다.",
    mockMode: "Mock 데이터로 확인 중입니다.",
    liveMode: "실시간 위치와 구역 설정을 한 화면에서 확인합니다.",
    connection: "연결",
    connected: "연결됨",
    waiting: "대기 중",
    updated: "업데이트",
    fusionActive: (count) => `${count}대 융합`,
    fusionSending: "융합 전송",
    fusionFallback: "융합 대기",
    connectedRadar: "연결된 레이더",
    coreStatus: "핵심 상태",
    presence: "재실",
    motion: "움직임",
    detected: "감지됨",
    notDetected: "감지 없음",
    targetCount: "대상 수",
    targetCountValue: (count) => `${count}개`,
    targetSummary: (moving, still) => `이동 ${moving} · 정지 ${still}`,
    staticRadarDetected: "보조 센서 · 감지됨",
    staticRadarClear: "보조 센서 · 감지 없음",
    staticRadarUnavailable: "보조 센서 · 없음",
    environment: "환경",
    floorplanReady: "평면도 준비됨",
    radarReady: "레이더맵 준비됨",
    targetLabel: (count) => `${count}개 대상`,
    savedFloorplanAria: "저장된 평면도",
    floorplanLoading: "평면도 불러오는 중",
    floorplanViewArea: "평면도 보기 영역",
    radarViewArea: "레이더맵 보기 영역",
    floorplanLoadFailed: (error) => `평면도를 불러오지 못했습니다. ${error}`,
    floorplanImageLoading: "저장된 평면도 이미지를 불러오고 있습니다.",
    radarFallback: "저장된 평면도가 없으면 레이더맵이 이 영역에 표시됩니다.",
    quickNav: "빠른 이동",
    zoneStatus: "구역 상태",
    zone: "구역",
    userZones: (count) => `사용자 구역 ${count}개`,
    calibrationZones: (count) => `보정 구역 ${count}개`,
    filter: "차단",
    reduced: "둔감",
    disabled: "제외",
    exit: "퇴실",
    countValue: (count) => `${count}개`,
    deviceStatus: "기기 상태",
    firmware: "펌웨어",
    dashboard: "대시보드",
    wifi: "Wi-Fi",
    storage: "저장공간",
    storageUsed: (usage, percent) => `${usage} · ${percent} 사용 중`,
    uptime: "가동 시간",
    platformStatus: "플랫폼",
    platformReady: "준비됨",
    platformUnavailable: "사용 불가",
    platformMode: "동작 모드",
    platformStandalone: "단독",
    platformEnrolled: "연결됨",
    nodeId: "Node ID",
    siteId: "Site ID",
    checking: "확인 중",
    notConnected: "연결 안 됨",
    wifiExcellent: "매우 좋음",
    wifiGood: "좋음",
    wifiFair: "보통",
    wifiWeak: "약함",
    wifiVeryWeak: "매우 약함",
    systemInfoFailed: (error) => `시스템 정보를 읽지 못했습니다. ${error}`,
    advancedSettings: "고급 설정",
    collapse: "접기",
    expand: "펼치기",
    advancedTuning: "고급 튜닝",
    advancedTuningDescription: "자주 쓰지 않는 기기 제어를 모아둡니다.",
    ledBehavior: "LED 동작",
    autoOff: "자동 꺼짐",
    environmentCorrection: "온습도 보정",
    legacyPresenceFallback: "구형 감지 fallback",
    legacyPresenceFallbackDescription: "디버깅이 필요할 때만 기존 람다 기반 재실 경로를 사용합니다. 일반 사용에서는 꺼두세요.",
    enabled: "켜짐",
    disabledState: "꺼짐",
    controlStatusFailed: (error) => `제어 상태를 읽지 못했습니다. ${error}`,
    statusLedControl: "Status LED 제어",
    diagnostics: "진단 정보",
    pairingButton: "기기 연결",
    pairing: {
      sharedFloorplan: "공유 평면도",
      sharedFloorplanDescription: "이 기기와 함께 연결되는 기기는 모두 같은 이미지와 방 구조를 사용합니다. 각 기기의 레이더 위치와 구역 설정은 그대로 유지됩니다.",
      sharedFloorplanOwner: "평면도를 제공하는 기기",
      sharedFloorplanRevision: "방 구조 버전",
      sharedFloorplanClaimOwner: "이 기기의 평면도를 함께 사용",
      sharedFloorplanOwnerClaimed: "이 기기의 평면도를 연결된 기기와 함께 사용합니다.",
      sharedFloorplanCommit: "연결된 기기에 현재 평면도 적용",
      sharedFloorplanSync: "공유 평면도 다시 받기",
      sharedFloorplanNotCommitted: "함께 사용할 평면도가 아직 선택되지 않음",
      sharedFloorplanCommitted: "같은 평면도 사용 중",
      sharedFloorplanCommitDone: "연결된 기기에서 현재 평면도를 함께 사용하도록 저장했습니다.",
      sharedFloorplanSyncStarted: "인증된 평면도 동기화를 시작했습니다.",
      sharedFloorplanAutoWaiting: (seconds) => `자동 동기화 순번 대기 · ${seconds}초`,
      replicationState: (state, result) => {
        if (state === "complete" && result === "ok") return "평면도가 최신 상태입니다";
        if (state === "requesting" || state === "receiving" || state === "committing") return "평면도 업데이트 중";
        if (state === "conflict") return "사용할 평면도를 다시 확인해야 합니다";
        if (state === "failed") return "평면도를 업데이트하지 못했습니다";
        return "평면도 업데이트 대기 중";
      },
      title: "NAMO 기기 연결",
      description: "주변 NAMO 기기를 안전하게 연결하고, 함께 사용할 평면도와 기기 위치를 설정합니다.",
      unavailable: "이 빌드 또는 데모에서는 보안 기기 연결을 사용할 수 없습니다.",
      localDevice: "이 기기",
      localDeviceDescription: "현재 기기의 연결 상태를 보여줍니다.",
      state: "연결 상태",
      floorplanUsage: "평면도 사용",
      floorplanUsageStates: {
        none: "저장된 평면도 없음",
        local: "이 기기에서만 사용 중",
        shared: "이 기기의 평면도를 함께 사용",
        received: "연결된 기기의 평면도 사용"
      },
      peer: "상대 기기",
      states: {
        idle: "시작하지 않음",
        prepared: "상대 기기 대기 중",
        exchanged: "보안 연결 확인 중",
        verified: "확인 코드 준비됨",
        committed: "안전하게 연결됨 · 설정 필요"
      },
      codeLabel: "확인 코드",
      codeHelp: "연결을 시작한 기기에 같은 코드가 보이는지 확인하세요.",
      confirmed: "이 기기에 보안 연결 정보를 저장했습니다.",
      receiveTitle: "다른 기기에서 연결할 수 있게 허용",
      receiveDescription: "다른 기기에서 이 기기를 찾고 연결하려면 먼저 누르세요.",
      allowIncoming: "3분 동안 연결 허용",
      incomingRequestTitle: "기기 연결 요청",
      incomingRequestDescription: "같은 네트워크의 NAMO 기기에서 연결을 요청했습니다. 요청한 기기가 맞을 때만 허용하세요.",
      incomingProgressTitle: "기기를 안전하게 연결하는 중",
      incomingProgressDescription: "연결을 시작한 기기에서 다음 단계를 진행하고 있습니다.",
      rejectIncoming: "거절",
      connectTitle: "다른 기기 추가",
      ownerRequiredTitle: "설정 원본 기기에서 추가",
      ownerRequiredDescription: "새 기기 연결은 공유 평면도와 연결 정보를 변경하므로 설정 원본 기기에서 진행해야 합니다.",
      ownerUnavailable: "설정 원본 기기가 현재 오프라인입니다. 다시 연결되거나 자동 대체가 완료된 뒤 시도하세요.",
      openOwnerDevice: "설정 원본으로 이동",
      connectionNotReadyTitle: "연결 정보 확인 중",
      connectionNotReadyDescription: "연결된 기기들이 최신 공유 설정을 확인한 뒤 새 기기를 추가할 수 있습니다. 감지는 계속됩니다.",
      resumeSetup: "연결 설정 계속",
      setupResumed: "새 기기에 공유 설정을 전달했습니다. 위치 맞추기를 계속할 수 있습니다.",
      nearbyDevices: "주변 NAMO 기기",
      nearbyDescription: "이미 연결된 기기는 위 목록에서 관리하며 다시 연결 대상으로 표시하지 않습니다.",
      searching: "주변 기기를 찾는 중...",
      noDevices: "연결 가능한 NAMO 기기를 찾지 못했습니다.",
      noDevicesDescription: "상대 기기에서 연결을 허용한 뒤 다시 찾거나 주소를 직접 입력하세요.",
      refreshDevices: "다시 찾기",
      manualAddress: "주소 직접 입력",
      manualAddressDescription: "네트워크에서 자동 발견을 사용할 수 없을 때 이용하는 보조 경로입니다.",
      address: "상대 기기 주소",
      connect: "보안 연결",
      confirm: "이 기기에서 확인",
      cancel: "연결 취소",
      connectedDevices: "연결된 기기",
      connectedDescription: "이 기기와 안전하게 연결된 NAMO 기기입니다. 위치 맞추기를 마치면 함께 감지할 수 있습니다.",
      pendingSetupTitle: (count) => `설정이 남은 기기 ${count}대`,
      pendingSetupDescription: (count) =>
        `${count}대는 안전하게 연결되었지만 위치 맞추기가 끝나지 않아 아직 융합에 참여하지 않습니다. 각 기기의 설정은 나중에 원하는 순서로 마칠 수 있으며, 그동안 다른 기기를 계속 추가해도 기존 연결은 유지됩니다.`,
      pendingSetupAddDescription: "설정이 남은 기기는 그대로 유지됩니다. 새 기기를 먼저 연결해도 되며, 위치 맞추기를 마친 기기부터 융합에 참여합니다.",
      noConnectedDevices: "연결된 기기가 없습니다",
      noConnectedDescription: "연결을 허용한 주변 기기가 아래 목록에 표시됩니다.",
      connectedCount: (count) => `${count}대 연결됨`,
      returnToMainDevice: "연결을 진행하던 기기로 돌아가기",
      membership: "상태",
      readiness: "설정",
      networkState: "네트워크",
      networkOnline: "온라인",
      networkUnavailable: "응답 없음",
      deviceAddress: "주소",
      deviceName: "이름",
      automaticFallback: "자동 대체",
      automaticFallbackAllowed: "허용됨",
      automaticFallbackNotAllowed: "허용 안 됨",
      automaticFallbackAllow: "자동 대체 허용",
      automaticFallbackDisable: "자동 대체 해제",
      automaticFallbackDescription: "다른 기기가 응답하지 않을 때 이 기기가 조정 역할을 이어받도록 허용할 수 있습니다. 각 기기의 기본 재실 감지는 이 설정과 관계없이 계속 작동합니다.",
      automaticFallbackEnabledNotice: "이 기기가 필요할 때 자동으로 조정 역할을 이어받을 수 있습니다.",
      automaticFallbackDisabledNotice: "이 기기의 자동 대체 권한을 해제했습니다.",
      automaticFallbackPreparedNotice: "위치 보정을 마쳤고, 이 기기가 필요할 때 자동으로 조정 역할을 이어받을 수 있습니다.",
      automaticFallbackPreparationFailed: "위치 보정은 완료했지만 자동 대체를 켜지 못했습니다. 연결된 기기 목록에서 자동 대체 허용을 눌러 다시 시도하세요.",
      singleFallbackWarning: "현재 온라인 상태에서 조정 역할을 맡을 수 있는 기기가 한 대뿐입니다. 연결된 다른 기기에 자동 대체를 허용하면 장애 시 역할을 이어받을 수 있습니다.",
      ready: "준비됨",
      notReady: "설정 필요",
      memberships: {
        quarantined: "연결됨 · 설정 필요",
        active: "사용 중",
        revoked: "해제 마무리 필요"
      },
      pendingDisconnects: "연동 해제 대기",
      pendingDisconnectsDescription: "이 기기에서는 차단됐으며 상대 기기가 응답하면 양쪽 해제를 마무리할 수 있습니다.",
      finishDisconnect: "해제 마무리",
      disconnect: "연동 해제",
      disconnectTitle: "두 기기 연동 해제",
      disconnectDescription: (participantId) => `${participantId}와의 연결 정보를 두 기기에서 모두 삭제합니다.`,
      pendingDisconnectDescription: (participantId) => `${participantId}의 남은 연결 기록을 정리합니다.`,
      disconnectAddressHelp: "상대 기기가 온라인이어야 합니다. 양쪽 기록을 지우기 전에 상대 기기 식별 정보를 확인합니다.",
      disconnectConfirm: "양쪽 모두 해제",
      retryDisconnect: "양쪽 해제 재시도",
      blockAndWait: "이 기기에서 차단",
      disconnectPendingNotice: "상대 기기의 연결 권한을 이 기기에서 차단했습니다. 양쪽 해제는 나중에 마무리할 수 있습니다.",
      deleteLocalRecord: "로컬 기록 삭제",
      localDeleteWarning: "로컬 기록을 삭제하면 상대 기기에 남은 연결 기록은 이 기기에서 더 이상 정리할 수 없습니다.",
      localRecordDeleted: "이 기기에서 남은 연결 기록을 삭제했습니다.",
      disconnecting: "연동 해제 중...",
      disconnected: "두 기기에서 연결 정보를 모두 삭제했습니다.",
      siteMemberRemoveTitle: "연결된 기기 제거",
      siteMemberRemoveDescription: (participantId) => `${participantId}의 공유 연결을 차단하고 해당 기기를 단독 센서로 전환한 뒤 목록에서 제거합니다.`,
      siteMemberRemoveAddressHelp: "대상 기기의 신원을 확인한 뒤 연결 정보만 초기화합니다. 평면도, 레이더 위치, 구역과 감도 설정은 유지됩니다.",
      siteMemberRemoveConfirm: "기기 제거",
      siteMemberRemoving: "기기 제거 중...",
      siteMemberRemoved: "대상 기기가 단독 센서로 전환되었고 공유 구성원 목록에서 제거되었습니다.",
      siteMemberForceRemove: "목록에서 강제로 제거",
      siteMemberForceRemoveWarning: "강제로 제거하면 이 기기의 공유 목록에서는 사라지지만 대상 기기에 이전 연결 정보가 남을 수 있습니다. 대상 기기에 접속할 수 있게 되면 관리 및 백업에서 기기 사이의 보안 연결을 초기화한 뒤 다시 연결하세요.",
      siteMemberForceRemoved: "대상 기기를 공유 구성원 목록에서 강제로 제거했습니다.",
      leaveSite: "연결된 Site에서 나가기",
      leaveSiteTitle: "이 Site에서 나가기",
      leaveSiteDescription: "설정 원본 기기에서 이 기기를 제거한 뒤 단독 센서로 재시작합니다. 평면도, 레이더 위치, 구역과 감도 설정은 유지됩니다.",
      leaveSiteAddressHelp: "공유 구성원 목록에서 제거되었는지 확인하려면 설정 원본 기기가 온라인이어야 합니다.",
      leaveSiteConfirm: "Site에서 나가기",
      leavingSite: "Site에서 나가는 중...",
      leftSite: "연결된 Site에서 제거되었습니다. 단독 모드로 재시작합니다.",
      setup: {
        title: "다른 NAMO 기기 연결",
        description: "이 화면에서 순서대로 진행합니다. 상대 기기에서는 연결 허용만 한 번 누르면 됩니다.",
        close: "설정 닫기",
        currentStep: "현재 단계",
        steps: {
          device: "기기 선택",
          select: "기기 선택",
          verify: "코드 확인",
          floorplan: "평면도 선택",
          complete: "마무리"
        },
        selectTitle: "추가할 기기를 선택하세요",
        selectDescription: "주변 기기를 선택하거나, 자동 검색이 안 될 때는 로컬 주소를 직접 입력하세요.",
        otherDevice: "주변 기기",
        manualAddress: "기기 주소",
        selectContinue: "계속",
        waitTitle: (name) => `${name}에서 연결을 허용하세요`,
        waitDescription: (seconds) => `최대 ${seconds}초 동안 기다립니다. 언제든 취소할 수 있습니다.`,
        openOtherDevice: "상대 기기 열기",
        waiting: "연결 허용 대기 중",
        waitingHelp: "상대 기기에서 ‘3분 동안 연결 허용’을 누르세요. 이후 과정은 이 화면에서 계속 진행합니다.",
        verifyTitle: "확인 코드를 비교하세요",
        verifyDescription: "상대 기기에 표시된 코드가 아래와 같을 때만 계속하세요.",
        code: "확인 코드",
        codeMatches: "코드가 같습니다",
        floorplanTitle: "함께 사용할 평면도를 선택하세요",
        floorplanDescription: "두 기기에 모두 평면도가 있으면 앞으로 함께 사용할 방 구조를 하나 선택합니다.",
        mockFloorplanRequired: "먼저 평면도를 생성하세요.",
        existingSiteFloorplan: "이 Site에서 사용 중인 평면도를 새 기기에 자동으로 전달합니다.",
        sameFloorplan: "두 기기에 이미 같은 평면도가 저장되어 있습니다.",
        thisFloorplan: "이 기기의 평면도 사용",
        otherFloorplan: (name) => `${name}의 평면도 사용`,
        noFloorplan: "저장된 평면도 없음",
        floorplanSummary: (bytes) => `${Math.max(1, Math.round(bytes / 1024))}KB 저장됨`,
        radarPositionKept: "각 기기의 레이더 위치는 그대로 유지됩니다",
        radarPositionHelp: "이미지와 방 구조만 공유합니다. 구역 설정과 각 기기의 레이더 위치는 덮어쓰지 않습니다.",
        fallbackTitle: "자동 대체 기기를 준비할까요?",
        fallbackDescription: "현재 연결된 시스템의 조정 역할을 맡을 수 있는 기기가 이 기기 한 대뿐입니다. 위치 보정 후 새 기기도 역할을 이어받을 수 있도록 허용하는 것을 권장합니다.",
        fallbackAccept: "자동 대체 준비",
        fallbackDecline: "허용하지 않고 계속",
        fallbackDeclineTitle: "자동 대체 없이 진행하는 것은 권장하지 않습니다",
        fallbackDeclineDescription: "한 기기에 여러 핵심 역할이 집중됩니다. 전원이나 네트워크에 문제가 생기면 공유 감지, 좌표 융합, 설정 관리가 중단될 수 있습니다. 자원 부담이 계속 커지면 기기가 불안정해지거나 재시작할 수도 있습니다.",
        fallbackGoBack: "자동 대체 준비하기",
        fallbackContinueWithout: "위험을 확인하고 계속",
        applying: "적용 중...",
        apply: "이 평면도 사용",
        completeTitle: "기기 연결 완료",
        completeDescription: "공유 평면도 전달을 완료했습니다. 이 기기에서 두 센서의 위치를 맞춘 뒤 함께 사용할 수 있습니다.",
        startCalibration: "위치 맞추기 시작",
        later: "나중에 하기",
        manageExisting: "상대 기기의 기존 연결 확인",
        done: "완료",
        error: (code) => {
          if (code === "peer_manages_existing_devices") {
            return "선택한 기기에 이미 연결된 다른 기기가 있습니다. 해당 기기에서 기존 연결을 먼저 확인하세요.";
          }
          if (code === "floorplan_required") {
            return "두 기기 중 한 곳에 평면도를 먼저 만든 뒤 연결하세요.";
          }
          if (code === "site_conflict") {
            return "선택한 기기에 이전 연결 정보가 남아 있습니다. 해당 기기에서 기존 연결을 확인하세요.";
          }
          if (code === "site_configuration_owner_required") {
            return "새 기기 연결은 설정 원본 기기에서 시작해야 합니다.";
          }
          if (code === "owner_mismatch") {
            return "확인한 설정 원본과 실제 설정 원본이 다릅니다. 설정 원본 기기에서 연결을 다시 시작하세요.";
          }
          if (code === "local_member_missing") {
            return "새 기기가 현재 Site의 연결 목록에 없습니다. 설정 원본 기기에서 연결을 다시 확인하세요.";
          }
          if (code === "site_mismatch") {
            return "새 기기에 다른 Site 정보가 남아 있습니다. 해당 기기에서 기존 연결을 확인하세요.";
          }
          if (code === "revision_conflict") {
            return "두 기기의 공유 설정이 서로 달라 자동으로 합칠 수 없습니다. 연결된 기기의 설정 상태를 확인하세요.";
          }
          if (code === "pairing_confirmation_uncertain") {
            return "보안 연결 응답을 확인하지 못했습니다. 저장된 연결 정보는 지우지 않았으므로 두 기기를 켜 둔 뒤 다시 시도하세요.";
          }
          if (code === "site_state_invalid") {
            return "선택한 기기의 연결 정보가 완전하지 않습니다. 기기를 다시 시작한 뒤 연결을 다시 시도하세요.";
          }
          if (code === "peer_rejected") {
            return "상대 기기에서 연결 요청을 거절했습니다.";
          }
          if (code === "site_owner_not_local") {
            return "이 기기에서 공유할 평면도 원본을 확정하지 못했습니다. 기존 연결 상태를 확인한 뒤 다시 시도하세요.";
          }
          if (code === "site_configuration_sync_timeout") {
            return "상대 기기의 평면도 동기화가 제한 시간 안에 끝나지 않았습니다. 두 기기의 네트워크 연결을 확인한 뒤 다시 시도하세요.";
          }
          if (code === "site_configuration_continuity_unavailable") {
            return "두 기기의 연결 정보 동기화가 끝나지 않았습니다. 두 기기를 켜 둔 뒤 다시 시도하세요.";
          }
          if (code === "site_configuration_conflict") {
            return "두 기기의 공유 연결 정보가 서로 다릅니다. 기존 연결 상태를 확인한 뒤 다시 시도하세요.";
          }
          if (code === "site_reconciliation_pending") {
            return "이 기기의 이전 연결 정보를 정리하고 있습니다. 잠시 후 다시 시도하세요.";
          }
          if (code === "site_reconciliation_failed") {
            return "이 기기의 이전 연결 정보를 저장하지 못했습니다. 기기를 재시작한 뒤 다시 시도하세요.";
          }
          if (code === "calibration_rollback_incomplete") {
            return "보정을 중단했지만 한 기기에서 연결이 비활성화되었는지 확인하지 못했습니다. 다시 시도하기 전에 두 기기의 연결 상태를 확인하세요.";
          }
          if (code === "group_full") {
            return "이 공간에는 이미 함께 사용할 수 있는 감지 기기 7대가 연결되어 있습니다.";
          }
          return "기기 연결을 완료하지 못했습니다. 잠시 후 다시 시도하세요.";
        }
      },
      calibration: {
        start: "보정 후 활성화",
        preparing: "위치 맞추기 준비 중",
        recalibrate: "다시 보정",
        title: "기기 위치 맞추기",
        description: (participantId) => `이 기기와 ${participantId}에서 같은 사람을 캡처한 뒤 보정안을 확인하고 활성화합니다.`,
        firstPosition: "첫 번째 위치",
        firstPositionHelp: "두 레이더가 모두 볼 수 있는 곳에 한 사람만 멈춰 선 뒤 한 번 캡처하세요.",
        secondPosition: "선택: 두 번째 위치",
        secondPositionHelp: "각도까지 보정하려면 옆으로 0.8m 이상 이동한 뒤 한 번 더 캡처하세요.",
        ready: "보정안 준비됨",
        readyHelp: "아래 보정값을 확인하세요. 두 기기에 저장된 레이더 배치 자체는 변경하지 않습니다.",
        steps: {
          check: "감지 확인",
          first: "첫 위치",
          second: "두 번째 위치",
          review: "확인 및 활성화"
        },
        views: {
          together: "함께 보기",
          reference: "이 기기",
          peer: "다른 기기"
        },
        thisDevice: "이 기기",
        placementRequiredTitle: "레이더 배치가 필요합니다",
        placementRequiredDescription: (deviceNames) =>
          `다음 기기에 저장된 레이더 위치가 없습니다: ${deviceNames}. 평면도에 위치가 보이더라도 아직 저장되지 않았을 수 있습니다. 해당 기기에서 레이더를 조금 움직인 뒤 저장하세요.`,
        placementCheckFailed:
          "기기에 저장된 레이더 위치를 확인하지 못했습니다. 두 기기의 연결 상태를 확인한 뒤 다시 시도하세요.",
        openRadarPlacement: (deviceName) => `${deviceName}에서 레이더 배치`,
        liveStatus: "실시간 감지",
        liveStatusHelp: "두 색의 점이 같은 사람을 가리키는지 확인하세요.",
        deviceOnline: "온라인",
        deviceOffline: "응답 없음",
        targetCount: (count) => `감지 대상 ${count}명`,
        targetSeparation: (millimeters) => `두 감지 위치 차이 ${millimeters}mm`,
        waitingForTargets: "두 기기에서 한 사람씩 감지되면 캡처할 수 있습니다.",
        mapAria: "두 기기의 레이더 위치와 감지 대상을 겹쳐 보여주는 보정 평면도",
        minimumBaseline: "이 원 밖으로 이동",
        captureFirst: "스냅샷 캡처",
        captureSecond: "두 번째 스냅샷 캡처",
        working: "처리 중...",
        samples: "스냅샷",
        translation: "위치 보정",
        rotation: "각도 보정",
        residual: "잔여 오차",
        room: "함께 감지할 방",
        reset: "처음부터",
        approveAndActivate: "승인하고 활성화",
        activated: "두 기기의 보정과 활성화를 완료했습니다.",
        error: (code) => {
          if (code === "calibration_pose_missing") {
            return "저장된 레이더 위치가 없는 기기가 있습니다. 보정 창을 닫고 해당 기기에서 레이더 위치를 저장하세요.";
          }
          if (code === "calibration_pose_contract_invalid") {
            return "보정에 사용된 위치 버전이 서로 맞지 않습니다. 보정 창을 닫았다가 다시 여세요.";
          }
          if (code === "calibration_scale_invalid") {
            return "저장된 평면도 축척 정보가 완전하지 않거나 서로 맞지 않아 위치를 보정할 수 없습니다.";
          }
          if (code === "calibration_floorplan_mismatch") {
            return "두 기기가 같은 버전의 평면도를 사용하지 않아 위치를 보정할 수 없습니다.";
          }
          if (code === "calibration_membership_inconsistent") {
            return "두 기기가 현재 연결의 활성 상태를 서로 다르게 알고 있습니다. 연결 상태를 확인한 뒤 다시 보정하세요.";
          }
          if (code === "group_full") {
            return "이 공간에는 이미 함께 사용할 수 있는 감지 기기 7대가 연결되어 있습니다.";
          }
          if (code === "site_leave_owner_mismatch") {
            return "선택한 기기가 더 이상 이 Site의 설정 원본이 아닙니다. 연결 목록을 새로 확인한 뒤 다시 시도하세요.";
          }
          if (code === "site_leave_owner_still_lists_node") {
            return "설정 원본 기기에서 이 기기 제거를 완료하지 못했습니다. 두 기기를 온라인으로 둔 뒤 다시 시도하세요.";
          }
          if (code === "calibration_rollback_incomplete") {
            return "위치 보정을 중단했지만 이전 좌표로 완전히 복원하지 못했습니다. 두 기기의 연결 상태를 확인하세요.";
          }
          return `기기 위치 보정 실패: ${code}`;
        }
      },
      error: (code) => {
        if (code === "site_configuration_owner_required") {
          return "새 기기 연결은 설정 원본 기기에서 시작해야 합니다.";
        }
        if (code === "site_conflict") {
          return "이 기기가 아직 다른 연결을 맡고 있습니다. 연결된 기기를 먼저 확인하세요.";
        }
        if (code === "pairing_confirmation_uncertain") {
          return "상대 기기의 보안 연결 완료 여부를 확인하지 못했습니다. 연결 기록은 유지했습니다.";
        }
        if (code === "owner_mismatch") return "설정 원본 기기가 변경되었습니다. 현재 설정 원본에서 다시 시도하세요.";
        if (code === "local_member_missing") return "이 기기가 Site 연결 목록에 없어 공유 설정을 받을 수 없습니다.";
        if (code === "site_mismatch") return "두 기기가 서로 다른 Site에 속해 있습니다.";
        if (code === "floorplan_manifest_invalid") {
          return "연결된 기기와 공유하기 전에 평면도를 완전히 저장하세요.";
        }
        if (code === "owner_offline") return "평면도를 제공하는 기기가 응답하지 않습니다.";
        if (code === "peer_not_ready") return "상대 기기에서 아직 연결을 허용하지 않았습니다.";
        if (code === "group_full") return "이 공간에는 이미 함께 사용할 수 있는 감지 기기 7대가 연결되어 있습니다.";
        if (code === "direct_pair_not_found") return "이 항목은 직접 연결 기록이 아니라 공유 구성원입니다. 설정 원본 기기에서 다시 제거하세요.";
        if (code === "site_member_removal_owner_changed") return "기기 제거 중 설정 원본 기기가 변경되었습니다. 현재 설정 원본 기기에서 제거를 계속하세요.";
        if (code === "site_member_removal_superseded") return "기기 제거 중 공유 구성원 목록이 변경되었습니다. 현재 목록을 확인한 뒤 다시 시도하세요.";
        if (code === "site_member_removal_replication_pending") return "연결 차단 정보가 아직 다른 기기에 충분히 전달되지 않았습니다. 잠시 후 다시 시도하거나 목록에서 강제로 제거할 수 있습니다.";
        if (code === "site_member_removal_site_mismatch") return "선택한 주소의 기기가 예상한 공유 연결에 속해 있지 않아 초기화를 중단했습니다.";
        if (code === "site_member_not_canonical") return "선택한 기기가 현재 공유 구성원 목록에 없습니다. 목록을 새로 확인하세요.";
        if (code === "site_member_revoke_incomplete") return "대상 기기의 연결 차단 상태를 저장하지 못했습니다. 다시 시도하세요.";
        if (code === "site_member_reset_unconfirmed") return "대상 기기가 단독 센서로 전환되었는지 확인하지 못했습니다. 온라인 상태를 확인한 뒤 다시 시도하거나 목록에서 강제로 제거할 수 있습니다.";
        return "기기 연결을 완료하지 못했습니다. 잠시 후 다시 시도하세요.";
      }
    },
    changing: "변경 중...",
    haMode: "HA 모드로",
    edgeMode: "Edge 모드로",
    chooseMode: "사용 환경 선택",
    ledDialogDescription: "LED 동작과 재실 감지 시 자동 꺼짐 시간을 선택합니다.",
    turnOn: "켜기",
    turnOff: "끄기",
    always: "계속",
    seconds: (seconds) => `${seconds}초`,
    minutes: (minutes) => `${minutes}분`,
    hoursMinutes: (hours, minutes) => `${hours}시간 ${minutes}분`,
    environmentDialogDescription: "기기 내부 보정 사용 여부와 사용자 오프셋을 조정합니다.",
    correctionBehavior: "보정 동작",
    temperatureOffset: "온도 오프셋",
    humidityOffset: "습도 오프셋",
    timezone: "시간대",
    timezoneChange: "시간대 변경",
    timezoneDialogDescription: "일별 통계에 사용할 현지 시간대를 선택합니다.",
    timezoneSelectLabel: "기기 시간대",
    timezoneUseBrowser: "이 기기의 시간대 사용",
    timezoneBrowserDetected: (timezone) => `${timezone} 시간대를 확인했습니다.`,
    timezoneBrowserUnsupported: (timezone) => `${timezone} 시간대를 확인했지만 지원 목록에 없습니다. 시간대를 직접 선택하세요.`,
    timezoneBrowserUnavailable: "브라우저 시간대를 확인하지 못했습니다. 시간대를 직접 선택하세요.",
    timezoneWarningTitle: "오늘 통계가 초기화됩니다",
    timezoneWarning: "시간대를 변경하면 오늘 누적 통계와 오늘 히트맵을 삭제하고 0부터 다시 집계합니다. 완료된 과거 일별 기록은 유지됩니다.",
    timezoneApply: "변경하고 오늘 통계 초기화",
    timezoneOptions: {
      UTC: "(UTC+00:00) 협정 세계시",
      "Pacific/Honolulu": "(UTC-10:00) 호놀룰루",
      "America/Anchorage": "(UTC-09:00/-08:00) 앵커리지",
      "America/Los_Angeles": "(UTC-08:00/-07:00) 로스앤젤레스",
      "America/Denver": "(UTC-07:00/-06:00) 덴버",
      "America/Chicago": "(UTC-06:00/-05:00) 시카고",
      "America/New_York": "(UTC-05:00/-04:00) 뉴욕",
      "America/Sao_Paulo": "(UTC-03:00) 상파울루",
      "Europe/London": "(UTC+00:00/+01:00) 런던",
      "Europe/Berlin": "(UTC+01:00/+02:00) 베를린",
      "Africa/Johannesburg": "(UTC+02:00) 요하네스버그",
      "Asia/Dubai": "(UTC+04:00) 두바이",
      "Asia/Kolkata": "(UTC+05:30) 콜카타",
      "Asia/Bangkok": "(UTC+07:00) 방콕",
      "Asia/Shanghai": "(UTC+08:00) 상하이",
      "Asia/Seoul": "(UTC+09:00) 서울",
      "Asia/Tokyo": "(UTC+09:00) 도쿄",
      "Australia/Perth": "(UTC+08:00) 퍼스",
      "Australia/Sydney": "(UTC+10:00/+11:00) 시드니",
      "Pacific/Auckland": "(UTC+12:00/+13:00) 오클랜드"
    },
    noSavedFloorplan: "저장된 평면도 데이터가 없습니다."
  },
  zones: {
    title: "구역 설정",
    description: "레이더맵 위에서 감지 구역과 오탐 보정 구역을 편집합니다.",
    status: "상태",
    loaded: "데이터 확인됨",
    loading: "로딩 중",
    zones: "구역",
    calibration: "오탐 보정",
    detection: "감지",
    targetDetected: (count) => `타깃 ${count}개 감지 중`,
    count: (count) => `${count}개`,
    zoneSettings: "구역 설정",
    calibrationSettings: "오탐 보정",
    staticRadarTuning: "보조센서 감도",
    staticRadarUnavailable: "LD2410C가 감지되지 않습니다.",
    staticRadarTuningTitle: "LD2410C 감지 감도",
    staticRadarTuningDescription: "거리 띠를 선택해 해당 범위의 감도를 조절합니다. 이 화면을 닫으면 실시간 계측 모드는 자동으로 꺼집니다.",
    staticRadarTuningStarting: "보조센서 계측을 준비하는 중입니다.",
    staticRadarGateListAria: "LD2410C 거리 띠",
    staticRadarGateRange: (startMeters, endMeters) => `${startMeters}~${endMeters} m`,
    staticRadarGateAria: (gate, startMeters, endMeters, moveEnergy, stillEnergy) =>
      `G${gate}, ${startMeters.toFixed(2)}~${endMeters.toFixed(2)}미터, 이동 에너지 ${moveEnergy}, 정지 에너지 ${stillEnergy}`,
    staticRadarDistance: "감지 범위",
    staticRadarMovingEnergy: "이동 에너지",
    staticRadarStillEnergy: "정지 에너지",
    staticRadarDetection: "현재 상태",
    staticRadarDetected: "감지됨",
    staticRadarNotDetected: "감지 없음",
    staticRadarSensitivity: "감도",
    staticRadarApply: "선택 범위에 적용",
    staticRadarApplying: "적용 중",
    staticRadarApplyFailed: "보조센서 감도를 적용하지 못했습니다.",
    staticRadarLoadFailed: "보조센서 계측 정보를 불러오지 못했습니다.",
    staticRadarFactoryReset: "공장 감도로 초기화",
    staticRadarFactoryResetTitle: "LD2410C 설정 초기화",
    staticRadarFactoryResetDescription: "G0~G8 감도뿐 아니라 최대 감지 거리, 해제 시간, 거리 해상도와 Bluetooth를 포함한 LD2410C의 전체 설정이 공장 기본값으로 돌아갑니다.",
    staticRadarFactoryResetConfirm: "초기화",
    staticRadarFactoryResetting: "초기화 중",
    staticRadarFactoryResetFailed: "LD2410C 공장 초기화를 완료하지 못했습니다.",
    zonePanelTitle: "구역",
    zonesLoading: "구역 데이터를 불러오는 중입니다.",
    zonesEmpty: "아직 설정된 구역이 없습니다. 구역을 추가해 감지, 제외, 퇴실 구역을 만들어보세요.",
    addZone: "구역 추가",
    maxZonesReached: "최대 6개까지 설정했습니다.",
    maxZonesHint: "감지/제외/퇴실 구역은 최대 6개까지 만들 수 있습니다.",
    zoneDescription: "원하는 구역을 지정하고 이름을 붙이거나 감지 제외 또는 퇴실 경로로 설정할 수 있습니다.",
    zoneName: "구역 이름",
    zoneNamePlaceholder: "예: 침대, 책상, 커튼",
    deleteZone: "구역 삭제",
    selectOrAddZone: "구역을 추가하거나 선택하세요.",
    zoneTypePlaceholder: "구역 종류 선택",
    zoneValidationTitle: "구역 설정 확인",
    zoneValidationInstruction: "탐지, 제외, 둔감, 퇴실, 비활성화 중 하나를 선택한 후 다시 저장하세요.",
    zoneValidationItem: (name) => `${name}: 구역 종류가 선택되지 않았습니다.`,
    ownerRequiredTitle: "설정 원본 기기에서 편집",
    ownerRequiredDescription: "탐지 구역은 연결된 기기가 함께 사용하므로 설정 원본 기기에서만 편집할 수 있습니다.",
    ownerUnavailable: "설정 원본 기기가 현재 오프라인입니다.",
    openOwnerDevice: "설정 원본으로 이동",
    typeLabels: {
      detection: "탐지",
      filter: "제외",
      reduced: "둔감",
      disabled: "비활성화",
      exit: "퇴실"
    },
    calibrationPanelTitle: "오탐 보정",
    calibrationDescription: "반복적으로 감지되는 오탐 위치를 분석해 보정 구역으로 저장합니다.",
    calibrationStart: "오탐 보정 시작",
    calibrationStop: "보정 중지",
    calibrationStoppedByUser: "사용자가 보정을 중지했습니다.",
    calibrationActionAria: "오탐 보정 동작",
    delete: "삭제",
    toolbarAria: "구역 편집 도구",
    undo: "되돌리기",
    redo: "다시 실행",
    convertToRect: "사각형으로 정리",
    rect: "사각형",
    deleteSelected: "선택 항목 삭제",
    noneSelected: "선택 없음",
    calibrationZone: "보정 구역",
    calibrationZoneLabel: (index) => `보정 구역 ${index}`,
    lastUpdated: "마지막 업데이트",
    radarAria: "레이더맵",
    clearSelectionAria: "레이더 선택 해제",
    calibrationInfoAria: "보정 구역 정보",
    calibrationPointAria: "보정 구역 꼭짓점",
    zoneMoveAria: "구역 이동",
    zoneEdgeAddAria: "구역 꼭짓점 추가",
    zonePointAria: "구역 꼭짓점",
    sceneLoadingTitle: "레이더 화면 준비 중",
    sceneLoadingDescription: "상태 데이터를 기다리는 중입니다.",
    zoneLabel: (index) => `구역 ${index}`,
    exitPointLabel: (index) => `퇴실지점 ${index}`,
    mapStatus: (count) => `타깃 ${count}개 감지 중`,
    calibrationUnavailableNoDevice: "기기 연결 후 사용할 수 있습니다.",
    calibrationPirActiveCannotStart: "PIR 움직임이 감지되어 시작할 수 없습니다.",
    calibrationMaxZonesReached: (max) => `오탐 보정 구역은 최대 ${max}개까지 저장할 수 있습니다.`,
    calibrationSavedCount: (count, max) => `저장된 보정 구역 ${count}/${max}`,
    calibrationStaticRadarOnlyAvailable: "공간 보정 구역은 가득 찼지만 LD2410C 보조 센서 보정은 가능합니다.",
    geometryMessages: {
      polygonMaxPoints: (maxPoints) => `꼭짓점은 최대 ${maxPoints}개까지 추가할 수 있습니다.`,
      polygonMinPoints: (minPoints) => `다각형은 꼭짓점 ${minPoints}개 이상이 필요합니다.`,
      zonesMaxCount: (max) => `감지/제외/퇴실 구역은 최대 ${max}개까지 만들 수 있습니다.`,
      zoneMaxPoints: (maxPoints) => `꼭짓점은 zone당 최대 ${maxPoints}개까지 추가할 수 있습니다.`,
      zoneMinPoints: (minPoints) => `다각형은 꼭짓점 ${minPoints}개 이상이 필요합니다.`
    },
    calibrationStatus: {
      staticRadarStarted: "LD2410C 보조 센서 데이터 수집을 시작했습니다.",
      staticRadarFailed: "LD2410C 보조 센서 보정을 완료하지 못했습니다.",
      staticRadarTargetAppeared: "보조 센서 단독 보정 중 LD2450 타깃이 나타나 보정을 취소했습니다.",
      staticRadarAdjusted: (gate, fromSensitivity, toSensitivity) =>
        `LD2410C G${gate} 감도 ${fromSensitivity} -> ${toSensitivity}`,
      staticRadarStillDetected: "자동 보정 후에도 LD2410C 감지가 계속됩니다. 설치 위치 또는 수동 감도를 확인하세요.",
      staticRadarSamples: (count) => `LD2410C 샘플: ${count}`,
      completed: (zoneCount, gateCount) =>
        `보정 구역 ${zoneCount}개 생성, LD2410C 게이트 ${gateCount}개 조정을 완료했습니다.`,
      noPersistentFalsePositive: "지속적인 오탐이 확인되지 않아 변경하지 않았습니다.",
      startRequested: "보정 시작 요청",
      pirPassed: "PIR 조건 통과",
      sampleCollectionStarted: "타겟 샘플 수집 시작",
      started: "오탐 보정을 시작했습니다.",
      failureTitle: "보정 실패",
      stoppedTitle: "보정 중지",
      successTitle: "보정 완료",
      noTarget: "감지된 타겟이 없어 보정을 시작할 수 없습니다.",
      multipleTargets: "타겟이 여러 개 감지되어 보정을 시작할 수 없습니다.",
      pirCancelled: "PIR 움직임이 감지되어 보정을 취소했습니다.",
      multipleTargetsCancelled: "타겟이 여러 개 감지되어 보정을 취소했습니다.",
      timeout: "반복 감지 영역이 너무 넓거나 불안정해 보정 구역을 만들지 못했습니다.",
      candidateCreateFailed: "오탐 보정 후보를 만들지 못했습니다.",
      candidateCreateFailedLog: "오탐 보정 후보 구역 생성 실패",
      scoreAccepted: (acceptedBy) => `보정 기준 통과: ${acceptedBy}`,
      successByScore: "안정도 점수 기준을 통과했습니다.",
      successByRepeat: "반복 감지 영역 기준을 통과했습니다.",
      zoneCreated: (zoneId) => `${zoneId} 구역 생성`,
      saved: (score) => `오탐 보정 구역을 저장했습니다. 안정도 ${score}점`,
      running: (elapsedSeconds, maxSeconds) => `안정도 분석 중입니다. ${elapsedSeconds}s / 최대 ${maxSeconds}s`,
      waiting: "대기 중",
      waitingForTargetSample: "타겟 샘플 대기 중",
      collectingSamples: "샘플 수집 중",
      analyzingStability: "안정도 분석 중",
      readyToCreate: "보정 구역 생성 준비 완료",
      waitingWork: "보정 작업 대기 중",
      pirState: (motion) => `PIR 상태: ${motion ? "움직임 감지" : "움직임 없음"}`,
      collectionFinished: "수집 시간: 종료됨",
      collectionTime: (elapsedSeconds, minSeconds) => `수집 시간: ${elapsedSeconds}s / 최소 ${minSeconds}s`,
      samples: (samples, minSamples) => `샘플: ${samples} / 최소 ${minSamples}`,
      usedSamples: (samples) => `사용 샘플: ${samples}`,
      outliers: (samples) => `제외 샘플: ${samples}`,
      score: (score, threshold) => `안정도 점수: ${score} / ${threshold}`,
      acceptedBy: (acceptedBy) => `판정 기준: ${acceptedBy}`
    },
    calibrationDialog: {
      aria: "오탐 보정",
      title: "오탐 보정",
      runningDescription: "보정 데이터를 수집하고 있습니다.",
      doneDescription: "보정 작업이 종료되었습니다.",
      createdZones: (count) => `생성된 보정 구역: ${count}개`,
      adjustedStaticRadarGates: (count) => `조정된 LD2410C 게이트: ${count}개`,
      workItems: "작업 내역",
      errorLog: "오류 로그",
      debugLog: "디버그 로그",
      noLogs: "아직 기록된 로그가 없습니다.",
      stop: "보정 중지",
      close: "닫기"
    },
    protectedDialog: {
      aria: "오탐 보정 구역 안내",
      title: "오탐 보정 구역은 보호되어 있습니다",
      description: "오탐 보정 구역은 자동 보정으로 생성된 제외 영역입니다. 일반 구역 편집 중 실수로 변경되는 것을 막기 위해 레이더맵에서는 직접 선택하거나 편집하지 않습니다.",
      instruction: "비활성화 또는 삭제가 필요하면 왼쪽의 오탐 보정 목록에서 해당 구역을 선택해 관리하세요.",
      confirm: "확인"
    },
    shrinkDialog: {
      aria: "오탐 보정 구역 축소 확인",
      title: "보정 구역 최소 크기 보호",
      description: "최소 기능 보장을 위해 자동으로 설정된 크기보다 작게 수정하는 것은 추천드리지 않습니다. 진행하시겠습니까?",
      warning: "예를 선택하면 이 보정 구역의 최소 보장 크기 보호가 영구 해제되어 이후에는 경고 없이 축소할 수 있습니다.",
      no: "아니오",
      yes: "예"
    }
  },
  stats: {
    periodToday: "오늘",
    periodDays: (days) => `${days}일`,
    recentDays: (days) => `최근 ${days}일`,
    zoneLabel: (index) => `구역 ${index}`,
    filterLabel: (index) => `필터 ${index}`,
    reducedLabel: (index) => `둔감 ${index}`,
    performanceMessage: (periodLabel, hits) => `${periodLabel} 기준 ${hits}회의 오탐 후보를 차단 또는 둔감 처리했습니다.`,
    noPerformanceData: "아직 오탐 보정 성과가 쌓이지 않았습니다.",
    noStoredDates: "저장된 날짜 없음",
    noStoredConfirmedDates: "저장된 확정 일자가 없습니다.",
    missingDates: (count, dates, hasMore) => `중간 누락 ${count}일: ${dates.join(", ")}${hasMore ? " 외" : ""}`,
    noMissingDates: "중간에 끊긴 날짜가 없습니다.",
    title: "감지 통계",
    description: "오탐 차단, 둔감 처리, 구역 감지 횟수를 요약합니다.",
    status: "상태",
    error: "오류",
    refreshing: "갱신 중",
    dataReady: "데이터 확인됨",
    period: "기간",
    unselected: "미선택",
    storage: "저장",
    count: (count) => `${count}개`,
    detection: "감지",
    hits: (count) => `${count}회`,
    falsePositiveCorrection: "오탐 보정",
    refresh: "새로고침",
    readFailedTitle: "통계 데이터를 읽지 못했습니다.",
    emptyTitle: "아직 표시할 통계가 없습니다.",
    emptyDescription: "오탐 보정이나 구역 감지가 발생하면 오늘 통계부터 채워지고, 날짜가 바뀌면 확정 일자로 저장됩니다.",
    periodSelect: "기간 선택",
    periodAria: "통계 기간",
    summaryTitle: (label) => `${label} 요약`,
    selectedSummaryHint: "선택한 기간의 집계값",
    performanceTitle: "오탐 보정 성과",
    blockedAndReduced: "차단 + 둔감",
    topFilterZone: "주요 차단 구역",
    topReducedZone: "주요 둔감 구역",
    periodTrend: "기간별 흐름",
    periodTrendHint: "오늘부터 30일까지 비교",
    heatmapCellHits: (hits) => `${hits}회`,
    noRecord: "기록 없음",
    heatmapStatus: (label, totalHits, activeCells) => `${label} 감지 히트맵 · 누적 ${totalHits}회 · 활성 셀 ${activeCells}개`,
    heatmapEmpty: (label) => `${label} 감지 히트맵 · 누적 감지 위치 없음`,
    topDetectionZones: "구역 상위 감지",
    noDetectionZoneHits: "아직 감지 기록이 없습니다.",
    topFilterZones: "오탐 차단 상위 구역",
    noFilterZoneHits: "아직 필터 기록이 없습니다.",
    topReducedZones: "둔감 처리 상위 구역",
    noReducedZoneHits: "아직 둔감 처리 기록이 없습니다.",
    storageState: "저장 상태",
    recentConfirmedDates: "최근 확정 일자",
    storedDates: "저장된 날짜",
    storageRange: "저장 범위",
    middleMissing: "중간 누락",
    blocked: "차단",
    reduced: "둔감",
    zoneDetection: "구역 감지",
    zone: "구역"
  },
  backup: {
    exportConfigNotReady: "내보낼 설정이 아직 준비되지 않았습니다.",
    exportDoneMessage: "백업 파일을 내보냈습니다.",
    exportDoneStatus: "백업 파일을 만들었습니다.",
    exportFailed: (error) => `백업을 만들지 못했습니다. ${error}`,
    importJsonOnly: "JSON 파일만 가져올 수 있습니다.",
    importJsonExtensionError: "선택한 파일의 확장자가 .json이 아닙니다.",
    importBlockedMessage: "백업 파일을 가져올 수 없습니다. 아래 항목을 확인해 주세요.",
    importValidationFailedStatus: "백업 검증 실패",
    importWarningMessage: "백업 파일에 확인이 필요한 경고가 있습니다.",
    importWarningStatus: "백업 경고 확인 필요",
    importReadyMessage: "백업 파일 검증이 완료되었습니다. 현재 설정을 덮어쓸 수 있습니다.",
    importReadyStatus: "백업 검증 완료",
    importReadFailed: (error) => `백업 파일을 읽지 못했습니다. ${error}`,
    importPreparing: "백업 복원을 준비하고 있습니다.",
    importRunningStatus: "백업 복원 중",
    importConfigRunning: "구역 설정과 오탐 보정 구역을 장치에 저장하는 중입니다.",
    importConfigDone: "설정 저장 완료",
    importFloorplanWithImageRunning: "평면도 설정과 이미지를 장치에 복원하는 중입니다.",
    importFloorplanConfigRunning: "평면도 설정을 장치에 복원하는 중입니다.",
    importFloorplanDone: "평면도 복원 완료",
    importStatsRunning: "통계 데이터와 히트맵 기록을 장치에 복원하는 중입니다.",
    importStatsUploading: (percent) => `업로드 중 ${percent}%`,
    importStatsDone: "통계 복원 완료",
    importDoneMessage: (items) => `${items.join(", ")} 데이터를 가져왔습니다.`,
    importDoneStatus: "백업 복원 완료",
    importFailed: (error) => `백업 복원 중 오류가 발생했습니다. ${error}`,
    importCancelledStatus: "백업 가져오기를 취소했습니다.",
    progressConfig: "설정",
    progressFloorplan: "평면도",
    progressStats: "통계",
    progressWaiting: "대기 중",
    itemSettings: "설정",
    itemFloorplan: "평면도",
    itemStats: "통계",
    title: "백업 / 복원",
    description: "구역 설정, 오탐 보정 구역, 저장된 평면도와 이미지를 파일로 저장하거나 복원합니다.",
    status: "상태",
    dataReady: "데이터 확인됨",
    loading: "로딩 중",
    file: "파일",
    notSelected: "선택 안 됨",
    exportButton: "백업하기",
    importButton: "복원하기",
    backupFile: "백업 파일",
    emptyTitle: "백업 파일을 만들거나 복원할 파일을 선택하세요.",
    emptyDescription: "작업 결과와 가져올 데이터 선택 항목이 여기에 표시됩니다.",
    zones: "구역",
    calibration: "오탐 보정",
    filterReducedDisabled: "필터/둔감/제외",
    floorplan: "평면도",
    included: "포함",
    none: "없음",
    statistics: "통계",
    dailyDays: (days) => `일별 ${days}일`,
    heatmap: "히트맵",
    restoreProgress: "복원 진행",
    restoreProgressAria: "백업 복원 진행률",
    importData: "가져올 데이터",
    importZonesAndCalibration: "구역 설정과 오탐 보정 구역",
    importFloorplanAndImage: "평면도와 이미지",
    importStatsAndHeatmap: "통계 데이터와 히트맵",
    importErrorsTitle: "가져올 수 없는 이유",
    importWarningsTitle: "확인이 필요한 항목",
    importConfirmDescription: "가져오기를 진행하면 선택한 데이터만 현재 장치 설정에 덮어씁니다.",
    importing: "가져오는 중",
    importWaitingForStorage: "저장 작업 대기 중",
    importStorageBusyDescription: "다른 저장 작업을 장치에 쓰는 중입니다. 해당 저장이 끝난 뒤 복원을 시작할 수 있습니다.",
    importSelectedData: "선택한 데이터 가져오기",
    cancel: "취소",
    checking: "확인 중",
    waiting: "대기 중",
    checkFailed: "확인 실패",
    firmware: "펌웨어",
    dashboard: "대시보드",
    copy: "복사",
    enabled: "활성",
    disabledState: "비활성",
    apiKey: "API 키",
    apiKeyHidden: "API 키를 숨겼습니다.",
    apiKeyDemoTitle: "데모에서는 API 키를 확인할 수 없습니다.",
    apiKeyDemoMessage: "API 키 확인은 실제 장치에서만 사용할 수 있습니다.",
    apiKeyAutoHide: (seconds) => `${seconds}초 후 창이 자동으로 닫힙니다.`,
    apiKeyLoadFailed: "API 키를 불러오지 못했습니다.",
    apiKeyNotSet: "저장된 API 키가 없습니다. API 키 생성 또는 재발급이 필요합니다.",
    apiKeyCopied: "API 키를 복사했습니다.",
    apiKeyCopyFailed: "복사하지 못했습니다. 다시 확인해 주세요.",
    apiKeyReveal: "API 키 확인",
    apiKeyRegenerate: "API 키 재발급",
    apiKeyDescription: "Home Assistant 연결에 사용하는 키입니다. 외부에 노출되지 않도록 주의하세요.",
    apiKeyRegenerateConfirmTitle: "API 키를 재발급할까요?",
    apiKeyRegenerateConfirmDescription: "기존 Home Assistant 연결이 끊어집니다. 다시 연결하려면 새 키를 Home Assistant에 입력해야 합니다.",
    apiKeyRegenerateConfirm: "재발급",
    apiKeyRegenerating: "재발급 중...",
    apiKeyRegeneratedTitle: "새 API 키가 발급되었습니다.",
    apiKeyRegenerateFailed: "API 키를 재발급하지 못했습니다.",
    restoreDemoTitle: "데모에서는 복원할 수 없습니다.",
    restoreDemoOpenMessage: "데모 페이지에서는 실제 장치 데이터를 덮어쓰지 않도록 복원 작업을 막아두었습니다.",
    restoreDemoFileMessage: "백업 검증과 복원 API 호출은 실제 장치에서만 사용할 수 있습니다.",
    restoreDemoConfirmMessage: "선택한 백업 데이터는 실제 장치에서만 가져올 수 있습니다.",
    firmwareUpdateTitle: "펌웨어 업데이트",
    firmwareUpdateDescription: "서명된 NAMO 펌웨어 패키지를 확인한 뒤 장치에 설치합니다.",
    firmwareUpdateButton: "펌웨어 업데이트",
    firmwareManualDescription: "NAMO 펌웨어 패키지를 기기에 직접 업로드합니다.",
    firmwareTarget: "설치 대상",
    firmwareUploading: "업로드 중",
    firmwareVerifying: "응답 확인 중",
    firmwareUpload: "업로드",
    firmwareManualUpdate: "수동으로 업데이트",
    firmwareUploadingTitle: "펌웨어를 업로드하는 중입니다",
    firmwareVerifyingTitle: "장치 응답을 확인하는 중입니다",
    firmwareSuccessTitle: "업데이트 완료",
    firmwareCompletionDescription: "새 펌웨어가 적용되었고 기기가 정상적으로 다시 응답했습니다.",
    firmwarePreviousVersion: "이전 펌웨어",
    firmwareInstalledVersion: "설치된 펌웨어",
    firmwareVerifyFailedTitle: "재응답 확인 실패",
    firmwareFailedTitle: "업데이트 실패",
    firmwareReadyTitle: "업로드 준비됨",
    firmwareIdleTitle: "수동 업데이트 대기 중",
    firmwareUploadProgressAria: "펌웨어 업로드 진행률",
    firmwareVerifyProgressAria: "펌웨어 재응답 확인 진행률",
    firmwareDoNotClose: "업데이트 중에는 전원을 끄거나 브라우저를 닫지 마세요.",
    firmwareRebootDisconnectNote: "재부팅 중에는 대시보드 연결이 잠시 끊길 수 있습니다.",
    firmwareVerifyFailedHint: "업데이트가 진행되었을 수 있습니다. 장치가 정상 동작하면 수동으로 새로고침하세요.",
    firmwareFailedHint: "파일과 OTA 예비 공간을 확인한 뒤 다시 시도하세요.",
    firmwareReadyHint: (fileText) => `${fileText} · 업로드를 누르면 장치 업데이트가 시작됩니다.`,
    firmwareReadyWithOta: (otaSpace) => `업로드할 NAMO 펌웨어 파일을 선택하세요. OTA 예비 공간은 ${otaSpace}입니다.`,
    firmwareReadyWithoutOta: "업로드할 NAMO 펌웨어 파일을 선택하세요. OTA 예비 공간은 시스템 정보 조회 후 확인할 수 있습니다.",
    firmwareRebooting: "장치가 재부팅 중입니다.",
    firmwareWaitingResponse: "장치 응답을 기다리는 중입니다.",
    firmwareCheckingApplied: "새 펌웨어 적용 여부를 확인하는 중입니다.",
    firmwareVerifyTimeout: "장치 응답을 확인하지 못했습니다. 전원과 네트워크를 확인한 뒤 수동으로 새로고침하세요.",
    firmwareAppliedReload: "업데이트가 적용되었습니다. 대시보드를 새로고침합니다.",
    firmwareSameVersionReload: "장치가 다시 응답했습니다. 같은 버전의 펌웨어를 다시 설치했을 수 있습니다. 대시보드를 새로고침합니다.",
    firmwareRespondedReload: "장치가 다시 응답했습니다. 대시보드를 새로고침합니다.",
    firmwareDemoTitle: "데모에서는 업데이트할 수 없습니다.",
    firmwareDemoOpenMessage: "펌웨어 업로드는 장치를 재부팅할 수 있는 작업이라 데모에서는 API 호출을 모두 막아두었습니다.",
    firmwareDemoFileMessage: "선택한 펌웨어 파일은 업로드되지 않습니다. 실제 장치에서만 업데이트를 진행할 수 있습니다.",
    firmwareBinOnly: "NAMO 서명 펌웨어(.namo-ota) 또는 개발용 .bin 파일만 업로드할 수 있습니다.",
    firmwareImageInvalid: "ESP32용 NAMO 펌웨어 정보를 확인할 수 없는 파일입니다.",
    firmwareFileTooLarge: (fileSize, otaSpace) => `파일이 OTA 예비 공간보다 큽니다. ${fileSize} / ${otaSpace}`,
    firmwareApiNotReady: "펌웨어 업로드 API가 준비되지 않았습니다.",
    firmwareFileReady: "파일을 확인했습니다. 업로드 버튼을 누르면 업데이트를 시작합니다.",
    firmwareUploadingMessage: "펌웨어를 업로드하는 중입니다. 업데이트 중에는 전원을 끄지 마세요.",
    firmwareUploadResponseLost: "업로드 응답이 끊겼습니다. 장치 응답을 확인합니다.",
    firmwareUploadInterrupted: "업로드 또는 재부팅 확인이 중단되었습니다. 펌웨어 파일을 다시 선택해 시도하세요.",
    firmwareUpdateFailedMessage: "펌웨어 업데이트에 실패했습니다.",
    firmwareUpdatedVersion: (before, after) => `펌웨어 업데이트 완료: ${before} → ${after}`,
    firmwareRebuiltVersion: (version) => `펌웨어 ${version}의 새 빌드를 다시 설치했습니다.`,
    firmwareReinstalledVersion: (version) => `펌웨어 ${version}을 다시 설치했습니다.`,
    alphaFirmwareAllow: "알파 펌웨어 설치 허용",
    alphaFirmwareArmed: (seconds) => `알파 펌웨어 1회 설치 허용됨 · ${Math.ceil(seconds / 60)}분 이내`,
    alphaFirmwareUnavailable: "이 펌웨어에서는 서명된 알파 설치 허용을 사용할 수 없습니다.",
    alphaFirmwareConfirmTitle: "알파 펌웨어를 허용할까요?",
    alphaFirmwareConfirmDescription: "알파 펌웨어는 검증이 덜 된 개발 빌드입니다. 설치 후 기능 불안정, 설정 손상 또는 반복 재부팅이 발생할 수 있습니다. 다음 10분 동안 이 기기에서 알파 펌웨어 1회 설치를 허용합니다.",
    alphaFirmwareConfirm: "10분 동안 1회 허용",
    alphaFirmwareUpdateFailed: "알파 펌웨어 설치 허용을 변경하지 못했습니다.",
    dangerZoneTitle: "위험 구역",
    dangerZoneDescription: "장치 연결, 보안 키, 저장된 설정을 되돌리는 작업입니다. 필요한 경우 먼저 백업을 만들어 두세요.",
    rebootButton: "재시작",
    rebootDevice: "장치 재시작",
    rebootDemoTitle: "데모에서는 재시작할 수 없습니다.",
    rebootDemoMessage: "재시작 API는 실제 기기에서만 호출할 수 있습니다.",
    rebootRequestedTitle: "재시작 요청 완료",
    rebootRequestedMessage: (seconds) => `약 ${seconds}초 뒤 기기를 재시작합니다.`,
    rebootFailedTitle: "재시작 실패",
    rebootFailedMessage: "재시작 중 오류가 발생했습니다.",
    rebootConfirmTitle: "장치를 재시작할까요?",
    rebootConfirmDescription: "확인을 누르면 기기를 재시작합니다.",
    rebooting: "재시작 중...",
    resetButton: "초기화",
    resetDemoTitle: "데모에서는 초기화할 수 없습니다.",
    resetDemoMessage: "초기화 API는 실제 기기에서만 호출할 수 있습니다.",
    resetSelectionRequiredTitle: "초기화 범위 선택 필요",
    resetSelectionRequiredMessage: "초기화할 항목을 하나 이상 선택해 주세요.",
    resetRebootSuffix: (seconds) => ` 설정 마무리를 위해 약 ${seconds}초 뒤 기기를 재부팅합니다.`,
    resetRequestedTitle: "초기화 요청 완료",
    resetRequestedMessage: (rebootSuffix) => `선택한 항목을 초기화했습니다.${rebootSuffix}`,
    resetFailedTitle: "초기화 실패",
    resetFailedMessage: "초기화 중 오류가 발생했습니다.",
    resetScopeTitle: "초기화 범위",
    resetScopeDescription: "초기화를 누른 뒤 아래 항목을 선택하고 확인 버튼을 누르면 최종 확인 팝업을 표시합니다.",
    resetItemsTitle: "초기화할 항목",
    resetSelectAll: "모두 선택",
    resetSpaceData: "평면도 이미지와 방 구조, 가구 배치, 레이더 위치",
    resetDetectionData: "사용자 감지 영역, 오탐 보정 영역, 감지 제외·둔감 설정, 환경 보정과 일반 설정",
    resetConnectionsData: "연결된 다른 기기 목록, 기기 사이의 보안 연결, 위치 맞춤과 융합 설정, 자동 대체 설정, 공유 중인 공간 정보",
    resetWifiData: "저장된 Wi-Fi 정보",
    resetStatsData: "통계 기록",
    resetSelected: "선택한 항목 초기화",
    resetIdleTitle: "초기화 대기 중",
    resetIdleDescription: "왼쪽의 초기화 버튼을 누르면 초기화 범위를 선택할 수 있습니다.",
    resetConfirmTitle: "초기화를 진행할까요?",
    resetConfirmDescription: "선택한 데이터가 삭제됩니다. 설정 데이터 또는 Wi-Fi 초기화를 포함하면 결과를 보낸 뒤 기기를 재부팅합니다.",
    resetConfirmButton: "초기화 진행",
    resetting: "초기화 중...",
    bootGuardHint: (seconds) => `부팅 직후 안전 확인 중입니다. ${seconds}초 후 사용할 수 있습니다.`,
    bootGuardTitle: "부팅 안정화 중",
    bootGuardNotice: (action, seconds) =>
      `${action}는 부팅 직후 ${seconds}초 동안 사용할 수 없습니다. OTA 롤백 감지와 장치 초기화를 안전하게 끝낸 뒤 다시 시도해 주세요.`,
    wifiNotConnected: "연결 안 됨",
    wifiExcellent: "매우 좋음",
    wifiGood: "좋음",
    wifiFair: "보통",
    wifiWeak: "약함",
    wifiVeryWeak: "매우 약함",
    uptimeDaysHours: (days, hours) => `${days}일 ${hours}시간`,
    uptimeHoursMinutes: (hours, minutes) => `${hours}시간 ${minutes}분`,
    uptimeMinutes: (minutes) => `${minutes}분`,
    systemInfoTitle: "시스템 정보",
    systemInfoDescription: "ESP32의 메모리, 저장소, 무선 연결 상태를 확인합니다.",
    flashOccupancy: "Flash 점유량",
    systemCheckingDescription: "장치 상태를 확인하는 중입니다.",
    systemSnapshotDescription: "탭 진입 시 한 번 조회한 값입니다.",
    systemReadFailed: "시스템 정보를 읽지 못했습니다",
    systemSection: "시스템",
    uptime: "가동 시간",
    storageSection: "저장 공간",
    usedWithPercent: (usage, percent) => `${usage} · ${percent} 사용 중`,
    firmwareSpace: "펌웨어 공간",
    otaSpace: "OTA 예비 공간",
    storageData: "저장 데이터",
    settingsStats: "설정/통계",
    internalRam: "내부 RAM",
    minInternalRamFree: "최저 내부 RAM 여유",
    externalRam: "외장 RAM",
    networkSection: "네트워크",
    systemWaitingTitle: "시스템 정보 대기 중",
    systemWaitingDescription: "관리 / 백업 탭에 진입하면 장치 상태를 한 번 확인합니다.",
    issueLine: (line) => `${line}번째 줄 · `,
    issueMessages: {
      backup_json_parse_failed: (params) =>
        params.column ? `JSON 파일을 읽을 수 없습니다. ${params.column}번째 글자 근처를 확인하세요.` : "JSON 파일을 읽을 수 없습니다.",
      backup_root_not_object: () => "백업 파일의 최상위 값은 객체여야 합니다.",
      backup_app_mismatch: (params) => `이 앱에서 만든 백업 파일인지 확인할 수 없습니다. 예상 값은 ${params.expected}입니다.`,
      backup_format_version_unsupported: (params) => `지원하지 않는 백업 형식 버전입니다. 현재 지원 버전은 ${params.supported}입니다.`,
      backup_created_at_invalid: () => "백업 생성 시간이 없거나 올바르지 않습니다.",
      backup_checksum_missing: () => "체크섬이 없거나 형식이 올바르지 않습니다. 파일이 수동으로 수정되었을 수 있습니다.",
      backup_checksum_mismatch: () => "체크섬이 일치하지 않습니다. 백업 파일이 수동으로 수정되었거나 손상되었을 수 있습니다.",
      backup_config_not_object: () => "config 값은 객체여야 합니다.",
      backup_config_version_invalid: () => "config.version은 숫자여야 합니다.",
      backup_config_zones_not_array: () => "software zone 목록은 배열이어야 합니다.",
      backup_config_zones_too_many: (params) => `software zone은 최대 ${params.max}개까지만 가져올 수 있습니다. 현재 파일에는 ${params.actual}개가 들어 있습니다.`,
      backup_calibration_zones_not_array: () => "오탐 보정 구역 목록은 배열이어야 합니다.",
      backup_calibration_zones_too_many: (params) =>
        `오탐 보정 구역은 최대 ${params.max}개까지만 가져올 수 있습니다. 현재 파일에는 ${params.actual}개가 들어 있습니다.`,
      backup_config_floorplan_not_object: () => "floorplan 값이 객체가 아니어서 가져오지 않습니다.",
      backup_floorplan_not_object: () => "평면도 백업 값이 객체가 아니어서 가져오지 않습니다.",
      backup_floorplan_document_invalid: () => "평면도 설정 문서가 없거나 올바르지 않아 가져오지 않습니다.",
      backup_floorplan_image_not_object: () => "평면도 이미지 백업 값이 객체가 아니어서 가져오지 않습니다.",
      backup_floorplan_image_incomplete: () => "평면도 이미지 백업 정보가 부족합니다. mime, bytes, dataBase64가 필요합니다.",
      backup_stats_not_object: () => "통계 백업 값이 객체가 아니어서 가져오지 않습니다.",
      backup_stats_today_invalid: () => "오늘 통계 값이 객체가 아니어서 비워둡니다.",
      backup_stats_daily_invalid: () => "일별 통계 값이 배열이 아니어서 비워둡니다.",
      backup_stats_heatmap_invalid: () => "히트맵 값이 객체가 아니어서 가져오지 않습니다.",
      backup_zone_not_object: () => "구역 정보는 객체여야 합니다.",
      backup_zone_id_invalid: (params) =>
        params.kind === "calibration"
          ? `오탐 보정 구역 id는 calibration_1부터 calibration_${params.max}까지만 사용할 수 있습니다.`
          : `software zone id는 zone_1부터 zone_${params.max}까지만 사용할 수 있습니다.`,
      backup_zone_id_out_of_range: (params) =>
        params.kind === "calibration"
          ? `${params.id}는 사용할 수 없습니다. 오탐 보정 구역은 calibration_1부터 calibration_${params.max}까지만 지원합니다.`
          : `${params.id}는 사용할 수 없습니다. software zone은 zone_1부터 zone_${params.max}까지만 지원합니다.`,
      backup_zone_id_duplicate: (params) => `${params.id}가 중복되었습니다.`,
      backup_calibration_polygon_unsupported: () => "오탐 보정 구역은 현재 사각형만 가져올 수 있습니다.",
      backup_min_size_unlocked_invalid: () => "minSizeUnlocked 값이 boolean이 아니어서 false로 처리합니다.",
      backup_zone_name_not_string: () => "구역 이름은 문자열이어야 합니다.",
      backup_zone_name_too_long: (params) => `구역 이름은 공백 포함 최대 ${params.max}글자까지만 사용할 수 있습니다. 현재 이름은 ${params.actual}글자입니다.`,
      backup_zone_type_invalid: (params) => `구역 타입이 올바르지 않습니다. 허용 값은 ${params.allowed}입니다.`,
      backup_zone_shape_invalid: () => "구역 shape이 올바르지 않습니다. rect 또는 polygon만 사용할 수 있습니다.",
      backup_zone_points_not_array: () => "points 값은 배열이어야 합니다.",
      backup_zone_rect_points_invalid: (params) => `사각형 구역은 꼭짓점이 정확히 4개여야 합니다. 현재 꼭짓점은 ${params.actual}개입니다.`,
      backup_zone_polygon_points_invalid: (params) =>
        `다각형 구역은 꼭짓점이 최소 ${params.min}개, 최대 ${params.max}개여야 합니다. 현재 꼭짓점은 ${params.actual}개입니다.`,
      backup_zone_point_invalid: () => "각 꼭짓점은 [x, y] 형태여야 합니다.",
      backup_zone_point_number_invalid: () => "x, y 좌표는 숫자여야 합니다.",
      backup_zone_point_integer_invalid: () => "x, y 좌표는 정수 mm 값이어야 합니다.",
      backup_zone_point_x_out_of_range: (params) => `x 좌표가 허용 범위를 벗어났습니다: ${params.value}. 허용 범위는 ${params.min} ~ ${params.max}mm입니다.`,
      backup_zone_point_y_out_of_range: (params) => `y 좌표가 허용 범위를 벗어났습니다: ${params.value}. 허용 범위는 ${params.min} ~ ${params.max}mm입니다.`,
      backup_zone_points_all_zero: () => "모든 꼭짓점이 (0, 0)이어서 가져올 수 없습니다.",
      backup_zone_area_empty: () => "구역의 너비 또는 높이가 0입니다. 실제로 그릴 수 있는 면적이 있어야 합니다."
    }
  },
  floorplan: {
    candidateList: {
      title: "방 목록",
      noName: "이름 없음",
      confidence: (confidence) => `신뢰도 ${confidence}%`,
      approximateSize: (widthPx, heightPx, widthMm, heightMm) =>
        `${widthPx} x ${heightPx}px · 약 ${widthMm} x ${heightMm}mm`,
      roomNamePlaceholder: "방 이름",
      estimatedSize: "추정 크기",
      estimatedPixelBasis: (widthPx, heightPx) => `${widthPx} x ${heightPx}px 기준`,
      width: "가로",
      height: "세로",
      noCandidates: "아직 생성된 방이 없습니다.",
      status: {
        candidate: "후보",
        confirmed: "확정",
        rejected: "제외"
      },
      notes: {
        widthFromOuter: "가로 전체 기준",
        heightFromOuter: "세로 전체 기준",
        manuallyEdited: "직접 수정됨"
      },
      inline: {
        snapActive: "평면도에서 벽에 맞추는 중입니다.",
        splitActive: "평면도에서 방을 나누는 중입니다.",
        mergeSelected: "합칠 방으로 선택되었습니다.",
        mergePickMore: "합칠 방을 하나 더 선택하세요."
      },
      actions: {
        snap: "벽에 맞추기",
        split: "방 나누기",
        merge: "방 합치기",
        confirm: "확정",
        reject: "제외",
        remove: "삭제"
      }
    },
    ocrDialog: {
      busyTitle: "OCR 분석 중",
      errorTitle: "OCR 분석 확인",
      doneTitle: "OCR 분석 완료",
      progressAria: "OCR 진행률",
      cancelLabel: "작업 취소",
      cancelAction: "OCR 중단",
      closeLabel: "닫기",
      closeAction: "결과 확인"
    },
    editTools: {
      title: "편집 도구",
      split: "방 나누기",
      merge: "방 합치기",
      snap: "벽에 맞추기",
      door: "문 추가"
    },
    radarStep: {
      title: "레이더 배치",
      description: "입력한 전체 평면도 크기와 하늘색 최외곽 박스를 기준으로 레이더 배치를 준비합니다.",
      totalSize: "전체 크기",
      referenceBox: "기준 박스",
      scale: "스케일",
      scaleFineTune: "스케일 미세 보정",
      zoomOutAria: "레이더맵 축소",
      zoomInAria: "레이더맵 확대",
      scaleHint: "자동 스케일 기준에서 95~105%까지만 조정됩니다.",
      nextWork: "다음 작업: 평면도 위에서 레이더 위치와 방향을 지정합니다.",
      advancedOptions: "고급 옵션",
      occlusionTitle: "레이더 차폐 예외",
      occlusionDescription: "실제 감지가 벽을 통과하는 구간만 차폐 대상에서 제외합니다.",
      occlusionEditOn: "차폐 예외 편집",
      occlusionEditOff: "차폐 예외 편집 끝내기",
      occlusionActiveHint: "평면도의 물리 벽을 클릭해 차폐 적용 여부를 변경하세요.",
      occlusionIgnored: (count) => `차폐 예외 ${count}개`,
      occlusionReset: "예외 모두 초기화",
      previousStep: "이전 단계",
      roomsScale: "방 이름/스케일",
      nextStep: "다음 단계",
      finalReview: "최종 확인"
    },
    finalStep: {
      unavailable: "준비 불가",
      title: "최종 확인",
      description: "아직 ESP32에 저장하지 않았습니다. 지금까지 만든 설정을 한 번 확인합니다.",
      image: "이미지",
      config: "설정",
      roomCandidates: "방 후보",
      roomCount: (count) => `${count}개`,
      totalSize: "전체 크기",
      inputRequired: "입력 필요",
      radarPosition: "레이더 위치",
      rotation: "회전",
      occlusionExceptions: "차폐 예외",
      edgeCount: (count) => `${count}개`,
      jsonSize: "JSON 크기",
      checklistImage: "업로드 이미지를 ESP32 저장용 WebP 후보로 준비했습니다.",
      checklistRooms: "방 후보 정리와 방 이름 OCR 결과를 설정 후보에 반영했습니다.",
      checklistScale: "전체 평면도 크기 기준으로 레이더 스케일을 계산했습니다.",
      checklistRadar: "레이더 위치, 회전, 차폐 예외 설정을 저장 후보에 포함합니다.",
      cannotBuildJson: "저장 후보 JSON을 아직 만들 수 없습니다. 이미지와 전체 크기 입력 상태를 확인하세요.",
      previousStep: "이전 단계",
      radarPlacement: "레이더 배치",
      saving: "저장 중",
      save: "저장",
      saveAction: "저장하기"
    },
    debug: {
      count: (count) => `${count}개`,
      times: (count) => `${count}회`,
      chars: (count) => `${count}자`,
      none: "없음",
      selectedState: "선정",
      rejectedState: "제외",
      ocrDebug: "OCR 디버그",
      showOcrRegions: "OCR 영역 표시",
      ocrNotRun: "아직 OCR을 실행하지 않았습니다.",
      recognizedWords: "인식 단어",
      recognizedLines: "인식 줄",
      recognizedBlocks: "인식 블록",
      rawPieces: "원시 조각",
      mergedPieces: "병합 조각",
      wallBlockedMerges: "벽 차단 병합",
      textCandidates: "텍스트 후보",
      ocrCrops: "OCR crop",
      removedGuideLines: "제거한 가이드선",
      rotatedOcr: "회전 OCR",
      emptyCrops: "빈 crop",
      roomNameCandidates: "방 이름 후보",
      noiseCandidates: "잡음 후보",
      fullText: "전체 텍스트",
      preview: "미리보기",
      confidence: (confidence) => `신뢰도 ${confidence}%`,
      analysisLog: "분석 진행 로그",
      roomCandidateDebug: "방 후보 선정 디버그",
      showFloorplanDebug: "평면도 디버그 표시",
      showWallMaskOverlay: "벽 인식 영역 표시",
      analysisMethod: "분석 방식",
      candidatesBeforeCleanup: "정리 전 후보",
      finalCandidates: "최종 후보",
      candidateFilter: "후보 필터",
      filterOff: "해제",
      filterOn: "적용",
      edgeAnalysisDetail: "edge 분석 상세",
      colorFillAnalysisDetail: "색상/채움 분석 상세",
      wallLineAnalysisDetail: "벽선 분석 상세",
      cellSize: "셀 크기",
      analysisGrid: "분석 격자",
      totalCells: "전체 셀",
      edgePixels: "edge 픽셀",
      wallCandidateCells: "벽 후보 셀",
      expandedWallCells: "확장 후 벽 셀",
      freeSpaceRegions: "자유공간 영역",
      cannyThreshold: "Canny 임계값",
      colorPixels: "색상 픽셀",
      colorCandidateCells: "색상 후보 셀",
      connectedRegions: "연결 영역",
      darkPixels: "어두운 픽셀",
      wallSelectionDebug: "벽 선정 디버그",
      wallCellCoordinates: "벽 셀 좌표",
      rejectedCandidates: "제외된 후보",
      saveWallSelectionDebugTxt: "벽 선정 디버그 txt 저장",
      wallSelectionDebugNote: "선정된 좌표와 제외된 좌표는 txt 파일에서 확인합니다.",
      wallSnapDebug: "벽 붙이기 디버그",
      checkedEdges: "검사한 면",
      notAxisAligned: "축으로 인정 안 됨",
      candidateQueries: "후보 조회",
      noRedCandidateLine: "빨간 후보선 없음",
      alreadyAligned: "이미 붙었다고 판단",
      moveAttempts: "이동 시도",
      wallSnapApplied: "벽 붙이기 적용",
      selfIntersectionRejected: "self-intersection 거부",
      overExpansionRejected: "과확장 거부",
      cornerAttempts: "코너 보강 시도",
      cornerApplied: "코너 보강 적용",
      noIntersection: "교차점 없음",
      nearExistingPoint: "기존 꼭짓점 근처",
      spikeCornerRejected: "뾰족한 코너 거부",
      cornerSelfIntersection: "코너 self-intersection",
      wallSnapLog: "벽 붙이기 로그",
      initialCandidateCells: "초기 후보 셀",
      expandedCells: "확장 후 셀",
      rejectedTooSmallBlob: "너무 작은 덩어리 제외",
      rejectedTooSmallArea: "면적이 너무 작아 제외",
      rejectedTooLargeArea: "면적이 너무 커 제외",
      rejectedSparse: "자유공간이 듬성듬성해 제외",
      rejectedThin: "지나치게 길쭉해 제외",
      imageLine: (width, height) => `이미지: ${width} x ${height}`,
      gridLine: (width, height, cellSize) => `격자: ${width} x ${height} / 셀 ${cellSize}px`,
      selectedWallCellsLine: (count) => `선정된 벽 셀: ${count}개`,
      rejectedWallCellsLine: (count) => `제외된 벽 후보 셀: ${count}개`,
      selectedReasonCountsHeader: "[선정 이유별 개수]",
      rejectedReasonCountsHeader: "[제외 이유별 개수]",
      selectedWallCellsHeader: "[선정된 벽 셀]",
      rejectedWallCandidateCellsHeader: "[제외된 벽 후보 셀]",
      reasonCountLine: (reason, count) => `${reason}: ${count}개`
    },
    panel: {
      selectImageStatus: "평면도 이미지를 선택해 주세요.",
      uploadThenAnalyze: "평면도 업로드 후 방을 자동으로 인식할 수 있습니다.",
      canUseEsp32Candidate: "ESP32 저장 후보로 사용할 수 있습니다.",
      canAnalyzeRooms: "방 자동 인식을 실행할 수 있습니다.",
      unsupportedImageType: "PNG, JPG, WebP 이미지만 업로드할 수 있습니다.",
      imageTooLarge: "이미지 파일이 너무 큽니다. 5MB 이하 파일을 사용해 주세요.",
      imageTooSmall: "이미지가 너무 작습니다. 긴 변 800px, 짧은 변 500px 이상의 이미지를 사용해 주세요.",
      webpTooLarge: "글자 인식 품질을 유지하면서 80KB 이하 WebP로 변환하지 못했습니다.",
      canvasUnavailable: "이미지를 변환할 수 없습니다. Canvas를 사용할 수 없습니다.",
      webpFailed: "WebP 변환에 실패했습니다.",
      autoDetectingRooms: "벽선을 기준으로 방을 자동으로 인식하고 있습니다.",
      autoAnalysisStarted: "방 자동 인식을 시작했습니다.",
      analysisCanvasFailed: "이미지 분석에 사용할 Canvas를 준비하지 못했습니다.",
      pixelDataReady: "이미지 픽셀 데이터를 준비했습니다.",
      wallAnalysisRunning: "벽선 분석을 실행하고 있습니다.",
      roomCandidatesFound: (count) => `방 후보 ${count}개를 찾았습니다.`,
      noRoomCandidates: "방 후보를 찾지 못했습니다.",
      autoAnalysisComplete: (count) => `방 자동 인식 완료: ${count}개`,
      error: (message) => `오류: ${message}`,
      stepTitle: {
        image: "1단계 · 이미지 준비",
        rooms: "2단계 · 방 자동 인식",
        ocr: "3단계 · 방 이름/스케일",
        radar: "4단계 · 레이더 배치",
        final: "5단계 · 최종 확인"
      },
      stepDescription: {
        image: "PNG/JPG/WebP를 업로드하면 브라우저 메모리에서 WebP 저장 후보를 만듭니다. ESP32에는 아직 저장하지 않습니다.",
        rooms: "자동으로 찾은 방 후보를 확인하고, 필요한 방은 추가·분할·합치기로 정리합니다.",
        ocr: "방 이름을 확인하고 전체 평면도 가로/세로 길이를 입력합니다.",
        radar: "정리된 방과 전체 스케일을 기준으로 레이더 배치를 준비합니다.",
        final: "ESP32에 저장하기 전에 이미지, 방 후보, 레이더 배치 설정을 확인합니다."
      },
      saveCannotBuild: "저장 후보를 만들 수 없습니다. 이미지와 전체 크기 입력을 확인하세요.",
      saveApiUnavailable: "평면도 저장 API가 준비되지 않았습니다.",
      saveInProgress: "ESP32에 평면도 이미지와 설정을 저장하는 중입니다.",
      saveDone: "평면도 이미지와 설정을 저장했습니다.",
      storedSizeRequired: "전체 가로/세로 길이를 모두 입력해야 저장할 수 있습니다.",
      storedSaveInvalid: "저장할 수 없습니다. 전체 가로/세로 길이를 확인하세요.",
      sizeRequired: "전체 평면도 가로/세로 길이를 입력해야 방 크기를 계산할 수 있습니다.",
      roomSizesCalculated: (count) => `방 ${count}개의 크기를 계산했습니다.`,
      roomSizeHint: "전체 평면도 가로/세로 길이를 입력하면 방 크기를 대략 계산할 수 있습니다.",
      preciseSizeHint: "정밀 보정을 열면 방별 추정 크기와 직접 수정 입력란을 볼 수 있습니다.",
      ocrNotRun: "아직 OCR을 실행하지 않았습니다.",
      ocrPreparing: "OCR 분석을 준비하고 있습니다.",
      ocrStarted: "OCR 분석을 시작했습니다.",
      ocrJob: {
        cancelled: "OCR 분석이 취소되었습니다.",
        engineLoading: "OCR 엔진을 불러오는 중입니다.",
        detectingText: "텍스트 후보 영역을 찾는 중입니다.",
        noTextRegions: "텍스트 후보 영역을 찾지 못했습니다.",
        preparingWorker: (regions) => `OCR Worker를 준비하는 중입니다. OCR 영역 ${regions}개를 인식합니다.`,
        recognizingRegion: (index, total) => `텍스트 후보 ${index}/${total} 영역을 인식하는 중입니다.`,
        recognizingRegionRotation: (index, total, rotationIndex, rotations) =>
          `텍스트 후보 ${index}/${total} 영역을 인식하는 중입니다. (${rotationIndex}/${rotations})`,
        mergingResults: "OCR 결과를 정리하는 중입니다.",
        done: "OCR 분석이 완료되었습니다.",
        tesseractMissing: "Tesseract.js를 불러왔지만 OCR 객체를 찾지 못했습니다.",
        tesseractCdnFailed: "Tesseract.js CDN 로딩에 실패했습니다.",
        imageDataFailed: "OCR용 이미지 데이터를 준비하지 못했습니다.",
        cropCanvasFailed: "OCR crop 이미지를 만들 수 없습니다.",
        cropScaleFailed: "OCR crop 확대 이미지를 만들 수 없습니다.",
        cropPngFailed: "OCR crop PNG 생성에 실패했습니다.",
        cropRotateFailed: "OCR crop 회전 이미지를 만들 수 없습니다.",
        statusLoadingCore: "OCR 코어를 불러오는 중입니다.",
        statusInitializingEngine: "OCR 엔진을 초기화하는 중입니다.",
        statusLoadingLanguage: "한글/영문 학습 데이터를 불러오는 중입니다.",
        statusInitializingApi: "OCR API를 초기화하는 중입니다.",
        statusRecognizingText: "텍스트를 인식하는 중입니다.",
        statusWorking: "OCR 작업을 처리하는 중입니다."
      },
      ocrUseOriginal: "원본 업로드 이미지를 OCR 입력으로 사용합니다.",
      ocrUseWebp: "WebP 저장 후보를 OCR 입력으로 사용합니다.",
      ocrMatches: (count) => `방 이름 후보 ${count}개를 방 영역 기준으로 매칭했습니다.`,
      ocrNoMatches: "방 영역 내부에서 적용할 수 있는 방 이름 후보를 찾지 못했습니다.",
      ocrDone: "OCR 분석이 완료되었습니다.",
      ocrDoneSummary: (textCandidates, regions, blocks, lines, words) =>
        `OCR 완료: 텍스트 후보 ${textCandidates}개, crop ${regions}개, 블록 ${blocks}개, 줄 ${lines}개, 단어 ${words}개를 찾았습니다.`,
      ocrCancelled: "OCR 분석이 취소되었습니다.",
      ocrCancelledByUser: "사용자가 OCR 분석을 취소했습니다.",
      ocrError: "OCR 분석 중 오류가 발생했습니다.",
      ocrCanceling: "OCR 분석을 취소하는 중입니다.",
      ocrCancelRequested: "OCR 작업 취소를 요청했습니다.",
      previousStep: "이전 단계",
      nextStep: "다음 단계",
      firstStep: "지금이 첫 단계입니다",
      imageReady: "이미지 준비",
      roomAutoDetect: "방 자동 인식",
      roomNameRecognition: "방 이름 인식",
      roomCandidateCleanup: "방 후보 정리",
      radarPlacement: "레이더 배치",
      goToOcrTitle: "방 이름 인식 단계로 이동합니다.",
      goToRadarTitle: "레이더 배치 단계로 이동합니다.",
      goToRadarDisabledTitle: "전체 평면도 가로/세로 길이를 모두 입력하세요.",
      analyzing: "분석 중",
      clearImage: "이미지 지우기",
      converting: "변환 중",
      selectImage: "이미지 선택",
      drawFloorplan: "직접 그리기",
      drawFloorplanHint: "전체 외곽선을 그린 다음 내부 벽으로 방을 나눕니다.",
      manualFloorplanName: "직접 그린 평면도",
      manualOutlineRequired: "계속하려면 전체 외곽선을 완성하세요.",
      manualRoomRequired: "레이더를 배치하기 전에 방을 하나 이상 추가하세요.",
      manualOutlineTitle: "집 전체 외곽선 그리기",
      manualOutlineHint: "집 전체의 바깥 모서리를 순서대로 찍으세요. 점은 0.5m 격자와 기존 모서리 선에 맞춰지고 실제 길이는 0.1m 단위로 표시됩니다.",
      manualOutlineCancelled: "작성 중이던 외곽선을 취소했습니다. 준비되면 외곽선 그리기를 다시 시작하세요.",
      manualStartOutline: "외곽선 다시 그리기",
      manualOutlineNeedPoints: "집 전체의 바깥 모서리를 3개 이상 찍으세요.",
      manualOutlineReady: "마지막으로 닫히는 변까지 확인한 뒤 완료를 누르세요. 방은 다음 단계에서 별도로 추가합니다.",
      manualOutlineInvalid: "외곽선이 서로 교차하거나 같은 모서리를 반복할 수 없습니다. 점을 조정한 뒤 완료하세요.",
      manualRoomsTitle: "외곽선 안에 방 추가하기",
      manualRoomsHint: "집 전체 외곽선이 준비되었습니다. 외곽선 안에 각 방을 별도의 다각형으로 추가하세요.",
      manualRoomsReady: (count) => `방 ${count}개를 추가했습니다. 방을 더 추가하거나 레이더 배치로 진행하세요.`,
      manualAddRoom: "방 추가",
      manualEditOutline: "외곽선 편집",
      manualOutlineEditTitle: "외곽선 편집",
      manualOutlineEditHint: "모서리를 끌어 옮기고, 변을 눌러 모서리를 추가하거나 모서리를 두 번 눌러 삭제할 수 있습니다.",
      manualOutlineEditReady: "외곽선과 모든 방의 위치가 정상입니다. 완료를 눌러 변경을 적용하세요.",
      manualOutlineEditInvalid: "모든 방이 교차 없는 외곽선 안에 들어오도록 조정한 뒤 완료하세요.",
      manualRoomInvalid: "방이 외곽선 안에 들어오는지, 방의 변이 서로 교차하지 않는지 확인하세요.",
      manualFloorplanLocked: "저장된 도면은 수정할 수 없습니다. 외곽선이나 방을 바꾸려면 이 평면도를 삭제하고 다시 그리세요.",
      manualDoorsTitle: "문 목록",
      manualDoorType: "문 종류",
      manualAddDoor: "문 추가",
      manualHingedDoor: "여닫이문",
      manualSlidingDoor: "미닫이문",
      manualDoorPlacementTitle: "벽에 문 배치하기",
      manualDoorPlacementHint: "커서를 벽 가까이 옮기면 문이 벽에 맞춰집니다. 문 본체를 끌어 같은 벽에서 이동하고 양끝을 끌어 길이를 조절하세요. 저장하면 해당 위치가 퇴실 지점으로 등록됩니다.",
      manualDoorWallRequired: "벽에서 너무 먼 위치입니다. 문을 놓을 벽을 직접 누르세요.",
      manualDoorWallTooShort: "선택한 벽은 이 문을 배치하기에 너무 짧습니다.",
      manualDoorOverlap: "이 위치에는 이미 다른 문이 있습니다. 겹치지 않는 벽 위치를 선택하세요.",
      manualNoDoors: "아직 추가된 문이 없습니다.",
      manualDoorExitZoneLimit: "문을 퇴실 지점으로 등록할 공간이 부족합니다. 소프트웨어 구역은 퇴실 지점을 포함해 최대 6개까지 사용할 수 있습니다.",
      manualDoorExitSaveUnavailable: "문의 퇴실 지점을 저장할 수 없습니다. 잠시 후 다시 시도하세요.",
      manualDeleteDoor: "문 삭제",
      manualPlaceDoorAria: "벽에 문 배치",
      statusPassed: "통과",
      statusCheckRequired: "확인 필요",
      statusWaiting: "대기",
      saveReady: "저장 준비",
      savingShort: "저장 중",
      totalFloorplanSize: "전체 평면도 크기",
      totalFloorplanSizeDescription: "하늘색 최외곽 박스를 기준으로 전체 가로/세로 길이를 입력하세요.",
      totalFloorplanSizeEditDescription: "하늘색 최외곽 박스를 기준으로 전체 가로/세로 길이를 수정합니다.",
      totalWidth: "전체 가로",
      totalHeight: "전체 세로",
      preciseTuning: "정밀 보정",
      closePreciseTuning: "정밀 보정 닫기",
      limitations: "제한사항",
      limitationsDescription: "최소 긴 변 800px, 짧은 변 500px 이상이며, 최종 WebP 후보는 80KB 이하여야 합니다.",
      workspaceAria: "평면도 작업 영역",
      editToolsAria: "평면도 편집 도구",
      storedEditToolsAria: "저장된 평면도 편집 도구",
      undoTitle: "되돌리기 (Ctrl+Z)",
      redoTitle: "다시하기 (Ctrl+Y)",
      scaledRadarMapTitle: "스케일링된 레이더맵 표시",
      radarMapTitle: "레이더맵 표시",
      radarMap: "레이더맵",
      finish: "완료",
      cancel: "취소",
      uploadedCandidateAria: "업로드한 평면도 WebP 후보",
      roomCandidateLayerAria: "방 후보 영역",
      addSplitPointAria: "방 분할점 추가",
      addManualRoomPointAria: "수동 방 꼭짓점 추가",
      zoomInTitle: "확대",
      zoomOutTitle: "축소",
      resetZoomTitle: "확대 초기화",
      toolTitleSnap: "벽에 맞추기",
      toolTitleSplit: "방 나누기",
      toolTitleMerge: "방 합치기",
      toolTitleManualRoom: "방 추가",
      snapSelectWall: "붙일 벽선을 선택한 뒤 완료를 누르세요.",
      snapSelectEdge: "맞출 방의 변을 선택하세요.",
      splitStart: "나눌 방 안에 분할선의 시작점을 찍으세요.",
      splitEnd: "끝점을 찍으세요. 가로/세로 방향으로 자동 정렬합니다.",
      splitReady: "나누기 완료를 누르면 방 2개로 나뉩니다.",
      splitInvalid: "분할선이 방을 제대로 가르지 못했습니다. 점을 다시 조정하세요.",
      mergeSelectTwo: "합칠 방 2개를 선택하세요.",
      mergeSelectOneMore: "합칠 다른 방을 하나 더 선택하세요.",
      mergeReady: "완료를 누르면 선택한 방 2개가 하나로 합쳐집니다.",
      manualNeedPoints: "평면도 위에 방 꼭짓점을 3개 이상 찍으세요.",
      manualReady: "완료를 누르면 새 방이 추가됩니다. 꼭짓점은 더 찍을 수 있습니다.",
      manualInvalid: "다각형이 올바르게 닫히도록 점을 조정한 뒤 완료하세요.",
      defaultRoomName: (index) => `방 ${index}`,
      defaultRoomCandidateName: (index) => `방 후보 ${index}`,
      storedLoading: "로딩중입니다",
      storedTitle: "저장된 평면도",
      storedDescription: "ESP32에 저장된 평면도 데이터를 확인했습니다.",
      storedState: "상태",
      storedDataReady: "데이터 확인됨",
      storedMode: "모드",
      storedModeView: "보기",
      storedModeEdit: "편집",
      storedFloorplan: "평면도",
      storedReady: "준비됨",
      storedRooms: "방",
      storedRoomCount: (count) => `${count}개`,
      storedView: "보기",
      storedEdit: "편집",
      storedCreateNew: "새로 만들기",
      storedReplace: "평면도 교체",
      storedDelete: "평면도 삭제",
      storedReplaceCancel: "교체 취소",
      floorplanOwnerRequiredTitle: "설정 관리 기기에서 평면도를 변경하세요",
      floorplanOwnerRequiredDescription: "연결된 NAMO 기기들이 함께 사용하는 평면도입니다. 설정 관리 기기로 이동하여 교체하거나 관리하세요.",
      floorplanOpenOwner: "설정 관리 기기로 이동",
      floorplanOwnerUnavailable: "설정 관리 기기의 주소를 확인할 수 없습니다. 해당 기기의 네트워크 연결을 확인하세요.",
      floorplanDeleteConnectedTitle: "연결된 기기를 해제한 뒤 평면도를 삭제하세요",
      floorplanDeleteConnectedDescription: "연결된 기기들은 평면도를 기준으로 좌표를 공유하고 융합합니다. 지금은 평면도를 교체할 수 있으며, 삭제하려면 먼저 다른 기기의 연동을 해제하세요.",
      floorplanRadarRelocatedTitle: "레이더 위치를 다시 설정해야 하는 기기가 있습니다",
      floorplanRadarRelocatedDescription: (count) => `새 좌표계 바깥에 있던 ${count}개 기기의 레이더를 평면도 중앙으로 옮겼습니다. 각 기기로 이동하여 레이더 위치를 다시 설정하세요.`,
      floorplanRadarRelocatedDevice: (address) => `${address}에서 위치 설정`,
      floorplanRadarRelocatedUnavailable: "기기가 오프라인이거나 주소를 확인할 수 없습니다.",
      storedSaving: "저장 중",
      storedSaveChanges: "변경사항 저장",
      storedSave: "저장",
      storedRoomEdit: "방 편집",
      storedRadarPosition: "레이더 위치 변경",
      storedZoneEdit: "구역 설정",
      storedCalibrationEdit: "오탐 영역 편집",
      storedFurniture: "가구 배치",
      storedScaleRecalculated: "전체 크기와 방별 추정 치수를 다시 계산했습니다.",
      storedSaveInProgress: "ESP32에 평면도 설정을 저장하는 중입니다.",
      storedSaveDone: "평면도 설정을 저장했습니다.",
      storedSaveComplete: "저장 완료",
      storedAddZoneUnavailable: "구역을 추가할 수 없습니다.",
      storedZoneAdded: "구역을 추가했습니다.",
      storedZoneDeleted: "구역을 삭제했습니다.",
      storedZoneRectified: "구역을 사각형으로 정리했습니다.",
      storedAddPointUnavailable: "꼭짓점을 추가할 수 없습니다.",
      storedZonePointAdded: "구역 꼭짓점을 추가했습니다.",
      storedCalibrationUpdated: "오탐 영역을 수정했습니다.",
      storedZoneUpdated: "구역을 수정했습니다.",
      storedZonePointDeleted: "구역 꼭짓점을 삭제했습니다.",
      storedFurnitureChanged: "가구 배치를 변경했습니다.",
      storedFurnitureAdded: "가구를 추가했습니다.",
      storedFurnitureRotated: "가구를 회전했습니다.",
      storedFurnitureDeleted: "가구를 삭제했습니다.",
      storedFurnitureLabel: (id, fallback) => ({
        bed: "침대",
        desk: "책상",
        dining_table: "식탁",
        sofa: "소파",
        tv_console: "TV장"
      })[id] ?? fallback,
      storedZoneEditorTitle: (source) => source === "calibration" ? "오탐 영역 편집" : "구역 설정",
      storedZoneEditorDescription: "평면도 위의 구역을 드래그하거나 꼭짓점을 움직여 수정합니다. 감지 구역의 변을 더블클릭하면 꼭짓점이 추가됩니다.",
      storedAddZone: "구역 추가",
      storedNoZones: (source) => source === "calibration" ? "등록된 오탐 영역이 없습니다." : "등록된 구역이 없습니다.",
      storedZonePointCount: (count) => `${count}점 다각형`,
      storedExitLineShape: "퇴실선",
      storedRectShape: "사각형",
      storedZoneName: "구역 이름",
      storedZoneNamePlaceholder: "예: 침대, 책상",
      storedDetection: "감지",
      storedFilter: "제외",
      storedDisabled: "비활성화",
      storedExit: "퇴실",
      storedConvertRect: "사각형으로 정리",
      storedDeletePoint: "선택 꼭짓점 삭제",
      storedBlock: "차단",
      storedReduced: "둔감",
      storedOff: "꺼짐",
      storedDeleteZone: "선택 구역 삭제",
      storedFurnitureTitle: "가구 배치",
      storedFurnitureDescription: "가구를 선택하면 선택한 방 중앙에 추가됩니다. 평면도 위에서 드래그해 위치를 조정하세요.",
      storedNoFurniture: "배치된 가구가 없습니다.",
      storedDeleteSelectedFurniture: "선택한 가구 삭제",
      storedRadarTitle: "레이더 위치 변경",
      storedRadarDescription: "오른쪽 평면도에서 레이더 본체를 드래그하거나 회전 핸들을 움직입니다.",
      storedPreviewAria: "저장된 평면도 미리보기",
      storedPreparingTitle: "평면도 데이터를 준비하는 중입니다",
      storedPreparingDescription: "이미지와 설정을 불러온 뒤 여기에 표시합니다.",
      storedDeleteTitle: "저장된 평면도를 삭제합니다",
      storedDeleteDescription: "모든 평면도 데이터가 삭제되며 복구할 수 없습니다. 진행하시겠습니까?",
      storedDeleteNo: "아니오",
      storedDeleteYes: "네, 삭제합니다",
      storedDeleting: "삭제 중",
      storedScaleSummary: (widthPx, heightPx, mmPerPxX, mmPerPxY) =>
        `기준 박스 ${widthPx.toFixed(2)} x ${heightPx.toFixed(2)}px · ${mmPerPxX.toFixed(2)} / ${mmPerPxY.toFixed(2)} mm/px`,
      storedOuterBoundsMissing: "저장된 최외곽 박스를 확인할 수 없습니다.",
      storedRotateCounterClockwiseTitle: "선택한 가구를 반시계 방향으로 90도 회전",
      storedRotateClockwiseTitle: "선택한 가구를 시계 방향으로 90도 회전",
      demoLivingRoom: "거실",
      demoRoom: "방"
    }
  }
};
